@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package farmafreelance.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.StringResource

private object CommonMainString0 {
  public val accept_button: StringResource by 
      lazy { init_accept_button() }

  public val accept_confirm_notice: StringResource by 
      lazy { init_accept_confirm_notice() }

  public val accept_no_cancel_notice: StringResource by 
      lazy { init_accept_no_cancel_notice() }

  public val ad_update_error: StringResource by 
      lazy { init_ad_update_error() }

  public val ad_updated_success: StringResource by 
      lazy { init_ad_updated_success() }

  public val add_date_caps: StringResource by 
      lazy { init_add_date_caps() }

  public val add_favorites: StringResource by 
      lazy { init_add_favorites() }

  public val add_to_batch: StringResource by 
      lazy { init_add_to_batch() }

  public val address_label: StringResource by 
      lazy { init_address_label() }

  public val address_label_caps: StringResource by 
      lazy { init_address_label_caps() }

  public val address_row: StringResource by 
      lazy { init_address_row() }

  public val ads_deleted: StringResource by 
      lazy { init_ads_deleted() }

  public val all_filter: StringResource by 
      lazy { init_all_filter() }

  public val already_have_account_button: StringResource by 
      lazy { init_already_have_account_button() }

  public val any_period: StringResource by 
      lazy { init_any_period() }

  public val app_name: StringResource by 
      lazy { init_app_name() }

  public val apply_button: StringResource by 
      lazy { init_apply_button() }

  public val at_hours: StringResource by 
      lazy { init_at_hours() }

  public val attention: StringResource by 
      lazy { init_attention() }

  public val availabilities_saved: StringResource by 
      lazy { init_availabilities_saved() }

  public val availabilities_to_save: StringResource by 
      lazy { init_availabilities_to_save() }

  public val available_shifts: StringResource by 
      lazy { init_available_shifts() }

  public val back_nav: StringResource by 
      lazy { init_back_nav() }

  public val batch_availability_mgmt: StringResource by 
      lazy { init_batch_availability_mgmt() }

  public val batch_publish_mgmt: StringResource by 
      lazy { init_batch_publish_mgmt() }

  public val batch_published_success: StringResource by 
      lazy { init_batch_published_success() }

  public val birth_date_label: StringResource by 
      lazy { init_birth_date_label() }

  public val birth_place_label: StringResource by 
      lazy { init_birth_place_label() }

  public val born_at: StringResource by 
      lazy { init_born_at() }

  public val born_on: StringResource by 
      lazy { init_born_on() }

  public val call_button: StringResource by 
      lazy { init_call_button() }

  public val cancel_button: StringResource by 
      lazy { init_cancel_button() }

  public val cancel_match_button: StringResource by 
      lazy { init_cancel_match_button() }

  public val cancel_match_confirm_msg: StringResource by 
      lazy { init_cancel_match_confirm_msg() }

  public val cap_label: StringResource by 
      lazy { init_cap_label() }

  public val cap_label_short: StringResource by 
      lazy { init_cap_label_short() }

  public val citizenship_label: StringResource by 
      lazy { init_citizenship_label() }

  public val citizenship_label_caps: StringResource by 
      lazy { init_citizenship_label_caps() }

  public val city_label: StringResource by 
      lazy { init_city_label() }

  public val city_label_short: StringResource by 
      lazy { init_city_label_short() }

  public val city_row: StringResource by 
      lazy { init_city_row() }

  public val city_zone_label: StringResource by 
      lazy { init_city_zone_label() }

  public val city_zone_placeholder: StringResource by 
      lazy { init_city_zone_placeholder() }

  public val clear_all_caps: StringResource by 
      lazy { init_clear_all_caps() }

  public val close_button: StringResource by 
      lazy { init_close_button() }

  public val configure_shift_range: StringResource by 
      lazy { init_configure_shift_range() }

  public val confirm_acceptance: StringResource by 
      lazy { init_confirm_acceptance() }

  public val confirm_action: StringResource by 
      lazy { init_confirm_action() }

  public val confirm_all_availabilities: StringResource by 
      lazy { init_confirm_all_availabilities() }

  public val confirm_caps: StringResource by 
      lazy { init_confirm_caps() }

  public val confirm_notice_final: StringResource by 
      lazy { init_confirm_notice_final() }

  public val confirm_now_button: StringResource by 
      lazy { init_confirm_now_button() }

  public val confirm_operation: StringResource by 
      lazy { init_confirm_operation() }

  public val contact_body: StringResource by 
      lazy { init_contact_body() }

  public val contact_subject: StringResource by 
      lazy { init_contact_subject() }

  public val contacts: StringResource by 
      lazy { init_contacts() }

  public val counterparty_accepted: StringResource by 
      lazy { init_counterparty_accepted() }

  public val data_festive_label: StringResource by 
      lazy { init_data_festive_label() }

  public val date_label_header: StringResource by 
      lazy { init_date_label_header() }

  public val degree_label_caps: StringResource by 
      lazy { init_degree_label_caps() }

  public val delete_ads_confirm_msg: StringResource by 
      lazy { init_delete_ads_confirm_msg() }

  public val delete_ads_title: StringResource by 
      lazy { init_delete_ads_title() }

  public val delete_button_caps: StringResource by 
      lazy { init_delete_button_caps() }

  public val delete_label: StringResource by 
      lazy { init_delete_label() }

  public val delete_notification_msg: StringResource by 
      lazy { init_delete_notification_msg() }

  public val delete_notification_title: StringResource by 
      lazy { init_delete_notification_title() }

  public val delete_selected: StringResource by 
      lazy { init_delete_selected() }

  public val description: StringResource by 
      lazy { init_description() }

  public val digital_signature: StringResource by 
      lazy { init_digital_signature() }

  public val director_registration_label: StringResource by 
      lazy { init_director_registration_label() }

  public val discount_active_badge: StringResource by 
      lazy { init_discount_active_badge() }

  public val discount_progress_label: StringResource by 
      lazy { init_discount_progress_label() }

  public val disdici_button: StringResource by 
      lazy { init_disdici_button() }

  public val edit_ad_title: StringResource by 
      lazy { init_edit_ad_title() }

  public val edit_data_pharmacy: StringResource by 
      lazy { init_edit_data_pharmacy() }

  public val edit_data_professional: StringResource by 
      lazy { init_edit_data_professional() }

  public val edit_label: StringResource by 
      lazy { init_edit_label() }

  public val edit_profile: StringResource by 
      lazy { init_edit_profile() }

  public val email_button: StringResource by 
      lazy { init_email_button() }

  public val email_label: StringResource by 
      lazy { init_email_label() }

  public val email_placeholder: StringResource by 
      lazy { init_email_placeholder() }

  public val email_row: StringResource by 
      lazy { init_email_row() }

  public val emergency_accepted_notice: StringResource by 
      lazy { init_emergency_accepted_notice() }

  public val emergency_cancel_blocked_label: StringResource by 
      lazy { init_emergency_cancel_blocked_label() }

  public val emergency_cancel_blocked_msg: StringResource by 
      lazy { init_emergency_cancel_blocked_msg() }

  public val emergency_click_for_details: StringResource by 
      lazy { init_emergency_click_for_details() }

  public val emergency_confirm_now: StringResource by 
      lazy { init_emergency_confirm_now() }

  public val emergency_counterparty_accepted: StringResource by 
      lazy { init_emergency_counterparty_accepted() }

  public val emergency_immediate_matching: StringResource by 
      lazy { init_emergency_immediate_matching() }

  public val emergency_label: StringResource by 
      lazy { init_emergency_label() }

  public val emergency_urgent_request: StringResource by 
      lazy { init_emergency_urgent_request() }

  public val end_label: StringResource by 
      lazy { init_end_label() }

  public val error_or_duplicates: StringResource by 
      lazy { init_error_or_duplicates() }

  public val error_sending: StringResource by 
      lazy { init_error_sending() }

  public val exit_app_confirm: StringResource by 
      lazy { init_exit_app_confirm() }

  public val exit_app_title: StringResource by 
      lazy { init_exit_app_title() }

  public val farmacia: StringResource by 
      lazy { init_farmacia() }

  public val farmacista: StringResource by 
      lazy { init_farmacista() }

  public val female_gender: StringResource by 
      lazy { init_female_gender() }

  public val festive_notice_banner: StringResource by 
      lazy { init_festive_notice_banner() }

  public val filter_label: StringResource by 
      lazy { init_filter_label() }

  public val filter_show_only: StringResource by 
      lazy { init_filter_show_only() }

  public val final_confirmation: StringResource by 
      lazy { init_final_confirmation() }

  public val final_logout: StringResource by 
      lazy { init_final_logout() }

  public val friday: StringResource by 
      lazy { init_friday() }

  public val from_label: StringResource by 
      lazy { init_from_label() }

  public val gender_label: StringResource by 
      lazy { init_gender_label() }

  public val gender_label_caps: StringResource by 
      lazy { init_gender_label_caps() }

  public val generate_shifts_caps: StringResource by 
      lazy { init_generate_shifts_caps() }

  public val go_to_login: StringResource by 
      lazy { init_go_to_login() }

  public val got_it: StringResource by 
      lazy { init_got_it() }

  public val home_stats_accepted: StringResource by 
      lazy { init_home_stats_accepted() }

  public val home_stats_confirmed: StringResource by 
      lazy { init_home_stats_confirmed() }

  public val home_stats_proposed: StringResource by 
      lazy { init_home_stats_proposed() }

  public val home_stats_to_confirm: StringResource by 
      lazy { init_home_stats_to_confirm() }

  public val hourly_rate_label: StringResource by 
      lazy { init_hourly_rate_label() }

  public val how_can_we_help: StringResource by 
      lazy { init_how_can_we_help() }

  public val identity_header: StringResource by 
      lazy { init_identity_header() }

  public val in_evaluation: StringResource by 
      lazy { init_in_evaluation() }

  public val include_only_label: StringResource by 
      lazy { init_include_only_label() }

  public val inconsistent_data: StringResource by 
      lazy { init_inconsistent_data() }

  public val interval_caps: StringResource by 
      lazy { init_interval_caps() }

  public val invalid_email: StringResource by 
      lazy { init_invalid_email() }

  public val language_chinese: StringResource by 
      lazy { init_language_chinese() }

  public val language_english: StringResource by 
      lazy { init_language_english() }

  public val language_french: StringResource by 
      lazy { init_language_french() }

  public val language_german: StringResource by 
      lazy { init_language_german() }

  public val language_greek: StringResource by 
      lazy { init_language_greek() }

  public val language_italian: StringResource by 
      lazy { init_language_italian() }

  public val language_portuguese: StringResource by 
      lazy { init_language_portuguese() }

  public val language_selector: StringResource by 
      lazy { init_language_selector() }

  public val language_spanish: StringResource by 
      lazy { init_language_spanish() }

  public val loading: StringResource by 
      lazy { init_loading() }

  public val location_contacts: StringResource by 
      lazy { init_location_contacts() }

  public val login_button: StringResource by 
      lazy { init_login_button() }

  public val login_subtitle: StringResource by 
      lazy { init_login_subtitle() }

  public val login_title: StringResource by 
      lazy { init_login_title() }

  public val male_gender: StringResource by 
      lazy { init_male_gender() }

  public val manage_availability_title: StringResource by 
      lazy { init_manage_availability_title() }

  public val mandatory_fields_notice: StringResource by 
      lazy { init_mandatory_fields_notice() }

  public val matching_title: StringResource by 
      lazy { init_matching_title() }

  public val monday: StringResource by 
      lazy { init_monday() }

  public val my_favorites: StringResource by 
      lazy { init_my_favorites() }

  public val my_favorites_title: StringResource by 
      lazy { init_my_favorites_title() }

  public val name_label: StringResource by 
      lazy { init_name_label() }

  public val name_label_caps: StringResource by 
      lazy { init_name_label_caps() }

  public val name_row: StringResource by 
      lazy { init_name_row() }

  public val new_total: StringResource by 
      lazy { init_new_total() }

  public val no: StringResource by 
      lazy { init_no() }

  public val no_account_button: StringResource by 
      lazy { init_no_account_button() }

  public val no_ads_inserted: StringResource by 
      lazy { init_no_ads_inserted() }

  public val no_applications_received: StringResource by 
      lazy { init_no_applications_received() }

  public val no_available_shifts: StringResource by 
      lazy { init_no_available_shifts() }

  public val no_favorites_subtitle: StringResource by 
      lazy { init_no_favorites_subtitle() }

  public val no_favorites_yet: StringResource by 
      lazy { init_no_favorites_yet() }

  public val no_matches_active: StringResource by 
      lazy { init_no_matches_active() }

  public val no_message: StringResource by 
      lazy { init_no_message() }

  public val no_new_notifications: StringResource by 
      lazy { init_no_new_notifications() }

  public val no_pharmacies_found: StringResource by 
      lazy { init_no_pharmacies_found() }

  public val no_pharmacists_found: StringResource by 
      lazy { init_no_pharmacists_found() }

  public val nominative_label: StringResource by 
      lazy { init_nominative_label() }

  public val not_specified: StringResource by 
      lazy { init_not_specified() }

  public val notifications_title: StringResource by 
      lazy { init_notifications_title() }

  public val official_profile: StringResource by 
      lazy { init_official_profile() }

  public val ok_button: StringResource by 
      lazy { init_ok_button() }

  public val operating_area_title: StringResource by 
      lazy { init_operating_area_title() }

  public val operating_cap_label_caps: StringResource by 
      lazy { init_operating_cap_label_caps() }

  public val operating_city_label_caps: StringResource by 
      lazy { init_operating_city_label_caps() }

  public val order_registration_label: StringResource by 
      lazy { init_order_registration_label() }

  public val password_label: StringResource by 
      lazy { init_password_label() }

  public val pharmacist_details_title: StringResource by 
      lazy { init_pharmacist_details_title() }

  public val pharmacist_name_label: StringResource by 
      lazy { init_pharmacist_name_label() }

  public val pharmacists_needed: StringResource by 
      lazy { init_pharmacists_needed() }

  public val pharmacy_city_label: StringResource by 
      lazy { init_pharmacy_city_label() }

  public val pharmacy_city_placeholder: StringResource by 
      lazy { init_pharmacy_city_placeholder() }

  public val pharmacy_data: StringResource by 
      lazy { init_pharmacy_data() }

  public val pharmacy_name_label: StringResource by 
      lazy { init_pharmacy_name_label() }

  public val pharmacy_name_vat_label: StringResource by 
      lazy { init_pharmacy_name_vat_label() }

  public val pharmacy_pharmacist_fallback: StringResource by 
      lazy { init_pharmacy_pharmacist_fallback() }

  public val phone_label: StringResource by 
      lazy { init_phone_label() }

  public val phone_row: StringResource by 
      lazy { init_phone_row() }

  public val processing: StringResource by 
      lazy { init_processing() }

  public val professional_data: StringResource by 
      lazy { init_professional_data() }

  public val profile_detail_title: StringResource by 
      lazy { init_profile_detail_title() }

  public val profile_pharmacy: StringResource by 
      lazy { init_profile_pharmacy() }

  public val profile_professional: StringResource by 
      lazy { init_profile_professional() }

  public val progress_title: StringResource by 
      lazy { init_progress_title() }

  public val proposer_label: StringResource by 
      lazy { init_proposer_label() }

  public val province_label: StringResource by 
      lazy { init_province_label() }

  public val province_label_caps: StringResource by 
      lazy { init_province_label_caps() }

  public val province_label_short: StringResource by 
      lazy { init_province_label_short() }

  public val publish_availability_caps: StringResource by 
      lazy { init_publish_availability_caps() }

  public val publish_entire_batch: StringResource by 
      lazy { init_publish_entire_batch() }

  public val publish_shift_request_title: StringResource by 
      lazy { init_publish_shift_request_title() }

  public val range_festive_applied: StringResource by 
      lazy { init_range_festive_applied() }

  public val range_festive_notice: StringResource by 
      lazy { init_range_festive_notice() }

  public val rate_label_header: StringResource by 
      lazy { init_rate_label_header() }

  public val rate_label_pharmacist: StringResource by 
      lazy { init_rate_label_pharmacist() }

  public val rate_label_pharmacy: StringResource by 
      lazy { init_rate_label_pharmacy() }

  public val received_from: StringResource by 
      lazy { init_received_from() }

  public val region_label: StringResource by 
      lazy { init_region_label() }

  public val region_label_caps: StringResource by 
      lazy { init_region_label_caps() }

  public val region_label_short: StringResource by 
      lazy { init_region_label_short() }

  public val register_button_caps: StringResource by 
      lazy { init_register_button_caps() }

  public val register_title_screen: StringResource by 
      lazy { init_register_title_screen() }

  public val registration_success_message: StringResource by 
      lazy { init_registration_success_message() }

  public val registration_success_title: StringResource by 
      lazy { init_registration_success_title() }

  public val reject_button: StringResource by 
      lazy { init_reject_button() }

  public val release_shift_button: StringResource by 
      lazy { init_release_shift_button() }

  public val remember_me_label: StringResource by 
      lazy { init_remember_me_label() }

  public val remove_button: StringResource by 
      lazy { init_remove_button() }

  public val remove_favorites: StringResource by 
      lazy { init_remove_favorites() }

  public val reputation_insufficient_data: StringResource by 
      lazy { init_reputation_insufficient_data() }

  public val reputation_title: StringResource by 
      lazy { init_reputation_title() }

  public val reset_filters: StringResource by 
      lazy { init_reset_filters() }

  public val saturday: StringResource by 
      lazy { init_saturday() }

  public val save_button: StringResource by 
      lazy { init_save_button() }

  public val save_changes: StringResource by 
      lazy { init_save_changes() }

  public val search_pharmacies_subtitle: StringResource by 
      lazy { init_search_pharmacies_subtitle() }

  public val search_pharmacies_title: StringResource by 
      lazy { init_search_pharmacies_title() }

  public val search_pharmacists_title: StringResource by 
      lazy { init_search_pharmacists_title() }

  public val select_at_least_one_date: StringResource by 
      lazy { init_select_at_least_one_date() }

  public val select_availability_range: StringResource by 
      lazy { init_select_availability_range() }

  public val select_button: StringResource by 
      lazy { init_select_button() }

  public val select_dates: StringResource by 
      lazy { init_select_dates() }

  public val select_language: StringResource by 
      lazy { init_select_language() }

  public val select_period_title: StringResource by 
      lazy { init_select_period_title() }

  public val select_role: StringResource by 
      lazy { init_select_role() }

  public val select_shift_range: StringResource by 
      lazy { init_select_shift_range() }

  public val selected_count_label: StringResource by 
      lazy { init_selected_count_label() }

  public val send_report_button: StringResource by 
      lazy { init_send_report_button() }

  public val sent_by: StringResource by 
      lazy { init_sent_by() }

  public val sent_by_short: StringResource by 
      lazy { init_sent_by_short() }

  public val settings_title: StringResource by 
      lazy { init_settings_title() }

  public val shifts_ready_to_publish: StringResource by 
      lazy { init_shifts_ready_to_publish() }

  public val single_date_caps: StringResource by 
      lazy { init_single_date_caps() }

  public val skills_filter_label: StringResource by 
      lazy { init_skills_filter_label() }

  public val start_label: StringResource by 
      lazy { init_start_label() }

  public val status_accepted: StringResource by 
      lazy { init_status_accepted() }

  public val status_accepted_caps: StringResource by 
      lazy { init_status_accepted_caps() }

  public val status_cancelled: StringResource by 
      lazy { init_status_cancelled() }

  public val status_confirmed: StringResource by 
      lazy { init_status_confirmed() }

  public val status_in_progress: StringResource by 
      lazy { init_status_in_progress() }

  public val status_proposed: StringResource by 
      lazy { init_status_proposed() }

  public val status_rejected: StringResource by 
      lazy { init_status_rejected() }

  public val status_waiting: StringResource by 
      lazy { init_status_waiting() }

  public val storico_title: StringResource by 
      lazy { init_storico_title() }

  public val sunday: StringResource by 
      lazy { init_sunday() }

  public val support_alternative: StringResource by 
      lazy { init_support_alternative() }

  public val support_email_body: StringResource by 
      lazy { init_support_email_body() }

  public val support_email_subject: StringResource by 
      lazy { init_support_email_subject() }

  public val support_feedback: StringResource by 
      lazy { init_support_feedback() }

  public val support_feedback_option: StringResource by 
      lazy { init_support_feedback_option() }

  public val support_intro: StringResource by 
      lazy { init_support_intro() }

  public val support_message_label: StringResource by 
      lazy { init_support_message_label() }

  public val support_message_placeholder: StringResource by 
      lazy { init_support_message_placeholder() }

  public val support_other_option: StringResource by 
      lazy { init_support_other_option() }

  public val support_report_option: StringResource by 
      lazy { init_support_report_option() }

  public val support_technical_option: StringResource by 
      lazy { init_support_technical_option() }

  public val support_title: StringResource by 
      lazy { init_support_title() }

  public val support_type_label: StringResource by 
      lazy { init_support_type_label() }

  public val surname_label: StringResource by 
      lazy { init_surname_label() }

  public val surname_label_caps: StringResource by 
      lazy { init_surname_label_caps() }

  public val surname_row: StringResource by 
      lazy { init_surname_row() }

  public val tab_ads: StringResource by 
      lazy { init_tab_ads() }

  public val tab_home: StringResource by 
      lazy { init_tab_home() }

  public val tab_profile: StringResource by 
      lazy { init_tab_profile() }

  public val tab_search: StringResource by 
      lazy { init_tab_search() }

  public val tax_code_error_invalid: StringResource by 
      lazy { init_tax_code_error_invalid() }

  public val tax_code_error_length: StringResource by 
      lazy { init_tax_code_error_length() }

  public val tax_code_label: StringResource by 
      lazy { init_tax_code_label() }

  public val tax_code_label_caps: StringResource by 
      lazy { init_tax_code_label_caps() }

  public val tax_code_row: StringResource by 
      lazy { init_tax_code_row() }

  public val thursday: StringResource by 
      lazy { init_thursday() }

  public val time_active_now: StringResource by 
      lazy { init_time_active_now() }

  public val time_label_header: StringResource by 
      lazy { init_time_label_header() }

  public val time_remaining: StringResource by 
      lazy { init_time_remaining() }

  public val total_per_shift: StringResource by 
      lazy { init_total_per_shift() }

  public val tuesday: StringResource by 
      lazy { init_tuesday() }

  public val type_min_chars: StringResource by 
      lazy { init_type_min_chars() }

  public val user_not_logged_in: StringResource by 
      lazy { init_user_not_logged_in() }

  public val vat_label_caps: StringResource by 
      lazy { init_vat_label_caps() }

  public val vat_number: StringResource by 
      lazy { init_vat_number() }

  public val view_in_calendar: StringResource by 
      lazy { init_view_in_calendar() }

  public val waiting_counterparty: StringResource by 
      lazy { init_waiting_counterparty() }

  public val waiting_final_confirmation: StringResource by 
      lazy { init_waiting_final_confirmation() }

  public val wednesday: StringResource by 
      lazy { init_wednesday() }

  public val welcome: StringResource by 
      lazy { init_welcome() }

  public val welcome_back: StringResource by 
      lazy { init_welcome_back() }

  public val yes: StringResource by 
      lazy { init_yes() }

  public val yes_cancel: StringResource by 
      lazy { init_yes_cancel() }

  public val your_active_ads: StringResource by 
      lazy { init_your_active_ads() }

  public val your_proposal: StringResource by 
      lazy { init_your_proposal() }

  public val zone_label_header: StringResource by 
      lazy { init_zone_label_header() }
}

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("accept_button", CommonMainString0.accept_button)
  map.put("accept_confirm_notice", CommonMainString0.accept_confirm_notice)
  map.put("accept_no_cancel_notice", CommonMainString0.accept_no_cancel_notice)
  map.put("ad_update_error", CommonMainString0.ad_update_error)
  map.put("ad_updated_success", CommonMainString0.ad_updated_success)
  map.put("add_date_caps", CommonMainString0.add_date_caps)
  map.put("add_favorites", CommonMainString0.add_favorites)
  map.put("add_to_batch", CommonMainString0.add_to_batch)
  map.put("address_label", CommonMainString0.address_label)
  map.put("address_label_caps", CommonMainString0.address_label_caps)
  map.put("address_row", CommonMainString0.address_row)
  map.put("ads_deleted", CommonMainString0.ads_deleted)
  map.put("all_filter", CommonMainString0.all_filter)
  map.put("already_have_account_button", CommonMainString0.already_have_account_button)
  map.put("any_period", CommonMainString0.any_period)
  map.put("app_name", CommonMainString0.app_name)
  map.put("apply_button", CommonMainString0.apply_button)
  map.put("at_hours", CommonMainString0.at_hours)
  map.put("attention", CommonMainString0.attention)
  map.put("availabilities_saved", CommonMainString0.availabilities_saved)
  map.put("availabilities_to_save", CommonMainString0.availabilities_to_save)
  map.put("available_shifts", CommonMainString0.available_shifts)
  map.put("back_nav", CommonMainString0.back_nav)
  map.put("batch_availability_mgmt", CommonMainString0.batch_availability_mgmt)
  map.put("batch_publish_mgmt", CommonMainString0.batch_publish_mgmt)
  map.put("batch_published_success", CommonMainString0.batch_published_success)
  map.put("birth_date_label", CommonMainString0.birth_date_label)
  map.put("birth_place_label", CommonMainString0.birth_place_label)
  map.put("born_at", CommonMainString0.born_at)
  map.put("born_on", CommonMainString0.born_on)
  map.put("call_button", CommonMainString0.call_button)
  map.put("cancel_button", CommonMainString0.cancel_button)
  map.put("cancel_match_button", CommonMainString0.cancel_match_button)
  map.put("cancel_match_confirm_msg", CommonMainString0.cancel_match_confirm_msg)
  map.put("cap_label", CommonMainString0.cap_label)
  map.put("cap_label_short", CommonMainString0.cap_label_short)
  map.put("citizenship_label", CommonMainString0.citizenship_label)
  map.put("citizenship_label_caps", CommonMainString0.citizenship_label_caps)
  map.put("city_label", CommonMainString0.city_label)
  map.put("city_label_short", CommonMainString0.city_label_short)
  map.put("city_row", CommonMainString0.city_row)
  map.put("city_zone_label", CommonMainString0.city_zone_label)
  map.put("city_zone_placeholder", CommonMainString0.city_zone_placeholder)
  map.put("clear_all_caps", CommonMainString0.clear_all_caps)
  map.put("close_button", CommonMainString0.close_button)
  map.put("configure_shift_range", CommonMainString0.configure_shift_range)
  map.put("confirm_acceptance", CommonMainString0.confirm_acceptance)
  map.put("confirm_action", CommonMainString0.confirm_action)
  map.put("confirm_all_availabilities", CommonMainString0.confirm_all_availabilities)
  map.put("confirm_caps", CommonMainString0.confirm_caps)
  map.put("confirm_notice_final", CommonMainString0.confirm_notice_final)
  map.put("confirm_now_button", CommonMainString0.confirm_now_button)
  map.put("confirm_operation", CommonMainString0.confirm_operation)
  map.put("contact_body", CommonMainString0.contact_body)
  map.put("contact_subject", CommonMainString0.contact_subject)
  map.put("contacts", CommonMainString0.contacts)
  map.put("counterparty_accepted", CommonMainString0.counterparty_accepted)
  map.put("data_festive_label", CommonMainString0.data_festive_label)
  map.put("date_label_header", CommonMainString0.date_label_header)
  map.put("degree_label_caps", CommonMainString0.degree_label_caps)
  map.put("delete_ads_confirm_msg", CommonMainString0.delete_ads_confirm_msg)
  map.put("delete_ads_title", CommonMainString0.delete_ads_title)
  map.put("delete_button_caps", CommonMainString0.delete_button_caps)
  map.put("delete_label", CommonMainString0.delete_label)
  map.put("delete_notification_msg", CommonMainString0.delete_notification_msg)
  map.put("delete_notification_title", CommonMainString0.delete_notification_title)
  map.put("delete_selected", CommonMainString0.delete_selected)
  map.put("description", CommonMainString0.description)
  map.put("digital_signature", CommonMainString0.digital_signature)
  map.put("director_registration_label", CommonMainString0.director_registration_label)
  map.put("discount_active_badge", CommonMainString0.discount_active_badge)
  map.put("discount_progress_label", CommonMainString0.discount_progress_label)
  map.put("disdici_button", CommonMainString0.disdici_button)
  map.put("edit_ad_title", CommonMainString0.edit_ad_title)
  map.put("edit_data_pharmacy", CommonMainString0.edit_data_pharmacy)
  map.put("edit_data_professional", CommonMainString0.edit_data_professional)
  map.put("edit_label", CommonMainString0.edit_label)
  map.put("edit_profile", CommonMainString0.edit_profile)
  map.put("email_button", CommonMainString0.email_button)
  map.put("email_label", CommonMainString0.email_label)
  map.put("email_placeholder", CommonMainString0.email_placeholder)
  map.put("email_row", CommonMainString0.email_row)
  map.put("emergency_accepted_notice", CommonMainString0.emergency_accepted_notice)
  map.put("emergency_cancel_blocked_label", CommonMainString0.emergency_cancel_blocked_label)
  map.put("emergency_cancel_blocked_msg", CommonMainString0.emergency_cancel_blocked_msg)
  map.put("emergency_click_for_details", CommonMainString0.emergency_click_for_details)
  map.put("emergency_confirm_now", CommonMainString0.emergency_confirm_now)
  map.put("emergency_counterparty_accepted", CommonMainString0.emergency_counterparty_accepted)
  map.put("emergency_immediate_matching", CommonMainString0.emergency_immediate_matching)
  map.put("emergency_label", CommonMainString0.emergency_label)
  map.put("emergency_urgent_request", CommonMainString0.emergency_urgent_request)
  map.put("end_label", CommonMainString0.end_label)
  map.put("error_or_duplicates", CommonMainString0.error_or_duplicates)
  map.put("error_sending", CommonMainString0.error_sending)
  map.put("exit_app_confirm", CommonMainString0.exit_app_confirm)
  map.put("exit_app_title", CommonMainString0.exit_app_title)
  map.put("farmacia", CommonMainString0.farmacia)
  map.put("farmacista", CommonMainString0.farmacista)
  map.put("female_gender", CommonMainString0.female_gender)
  map.put("festive_notice_banner", CommonMainString0.festive_notice_banner)
  map.put("filter_label", CommonMainString0.filter_label)
  map.put("filter_show_only", CommonMainString0.filter_show_only)
  map.put("final_confirmation", CommonMainString0.final_confirmation)
  map.put("final_logout", CommonMainString0.final_logout)
  map.put("friday", CommonMainString0.friday)
  map.put("from_label", CommonMainString0.from_label)
  map.put("gender_label", CommonMainString0.gender_label)
  map.put("gender_label_caps", CommonMainString0.gender_label_caps)
  map.put("generate_shifts_caps", CommonMainString0.generate_shifts_caps)
  map.put("go_to_login", CommonMainString0.go_to_login)
  map.put("got_it", CommonMainString0.got_it)
  map.put("home_stats_accepted", CommonMainString0.home_stats_accepted)
  map.put("home_stats_confirmed", CommonMainString0.home_stats_confirmed)
  map.put("home_stats_proposed", CommonMainString0.home_stats_proposed)
  map.put("home_stats_to_confirm", CommonMainString0.home_stats_to_confirm)
  map.put("hourly_rate_label", CommonMainString0.hourly_rate_label)
  map.put("how_can_we_help", CommonMainString0.how_can_we_help)
  map.put("identity_header", CommonMainString0.identity_header)
  map.put("in_evaluation", CommonMainString0.in_evaluation)
  map.put("include_only_label", CommonMainString0.include_only_label)
  map.put("inconsistent_data", CommonMainString0.inconsistent_data)
  map.put("interval_caps", CommonMainString0.interval_caps)
  map.put("invalid_email", CommonMainString0.invalid_email)
  map.put("language_chinese", CommonMainString0.language_chinese)
  map.put("language_english", CommonMainString0.language_english)
  map.put("language_french", CommonMainString0.language_french)
  map.put("language_german", CommonMainString0.language_german)
  map.put("language_greek", CommonMainString0.language_greek)
  map.put("language_italian", CommonMainString0.language_italian)
  map.put("language_portuguese", CommonMainString0.language_portuguese)
  map.put("language_selector", CommonMainString0.language_selector)
  map.put("language_spanish", CommonMainString0.language_spanish)
  map.put("loading", CommonMainString0.loading)
  map.put("location_contacts", CommonMainString0.location_contacts)
  map.put("login_button", CommonMainString0.login_button)
  map.put("login_subtitle", CommonMainString0.login_subtitle)
  map.put("login_title", CommonMainString0.login_title)
  map.put("male_gender", CommonMainString0.male_gender)
  map.put("manage_availability_title", CommonMainString0.manage_availability_title)
  map.put("mandatory_fields_notice", CommonMainString0.mandatory_fields_notice)
  map.put("matching_title", CommonMainString0.matching_title)
  map.put("monday", CommonMainString0.monday)
  map.put("my_favorites", CommonMainString0.my_favorites)
  map.put("my_favorites_title", CommonMainString0.my_favorites_title)
  map.put("name_label", CommonMainString0.name_label)
  map.put("name_label_caps", CommonMainString0.name_label_caps)
  map.put("name_row", CommonMainString0.name_row)
  map.put("new_total", CommonMainString0.new_total)
  map.put("no", CommonMainString0.no)
  map.put("no_account_button", CommonMainString0.no_account_button)
  map.put("no_ads_inserted", CommonMainString0.no_ads_inserted)
  map.put("no_applications_received", CommonMainString0.no_applications_received)
  map.put("no_available_shifts", CommonMainString0.no_available_shifts)
  map.put("no_favorites_subtitle", CommonMainString0.no_favorites_subtitle)
  map.put("no_favorites_yet", CommonMainString0.no_favorites_yet)
  map.put("no_matches_active", CommonMainString0.no_matches_active)
  map.put("no_message", CommonMainString0.no_message)
  map.put("no_new_notifications", CommonMainString0.no_new_notifications)
  map.put("no_pharmacies_found", CommonMainString0.no_pharmacies_found)
  map.put("no_pharmacists_found", CommonMainString0.no_pharmacists_found)
  map.put("nominative_label", CommonMainString0.nominative_label)
  map.put("not_specified", CommonMainString0.not_specified)
  map.put("notifications_title", CommonMainString0.notifications_title)
  map.put("official_profile", CommonMainString0.official_profile)
  map.put("ok_button", CommonMainString0.ok_button)
  map.put("operating_area_title", CommonMainString0.operating_area_title)
  map.put("operating_cap_label_caps", CommonMainString0.operating_cap_label_caps)
  map.put("operating_city_label_caps", CommonMainString0.operating_city_label_caps)
  map.put("order_registration_label", CommonMainString0.order_registration_label)
  map.put("password_label", CommonMainString0.password_label)
  map.put("pharmacist_details_title", CommonMainString0.pharmacist_details_title)
  map.put("pharmacist_name_label", CommonMainString0.pharmacist_name_label)
  map.put("pharmacists_needed", CommonMainString0.pharmacists_needed)
  map.put("pharmacy_city_label", CommonMainString0.pharmacy_city_label)
  map.put("pharmacy_city_placeholder", CommonMainString0.pharmacy_city_placeholder)
  map.put("pharmacy_data", CommonMainString0.pharmacy_data)
  map.put("pharmacy_name_label", CommonMainString0.pharmacy_name_label)
  map.put("pharmacy_name_vat_label", CommonMainString0.pharmacy_name_vat_label)
  map.put("pharmacy_pharmacist_fallback", CommonMainString0.pharmacy_pharmacist_fallback)
  map.put("phone_label", CommonMainString0.phone_label)
  map.put("phone_row", CommonMainString0.phone_row)
  map.put("processing", CommonMainString0.processing)
  map.put("professional_data", CommonMainString0.professional_data)
  map.put("profile_detail_title", CommonMainString0.profile_detail_title)
  map.put("profile_pharmacy", CommonMainString0.profile_pharmacy)
  map.put("profile_professional", CommonMainString0.profile_professional)
  map.put("progress_title", CommonMainString0.progress_title)
  map.put("proposer_label", CommonMainString0.proposer_label)
  map.put("province_label", CommonMainString0.province_label)
  map.put("province_label_caps", CommonMainString0.province_label_caps)
  map.put("province_label_short", CommonMainString0.province_label_short)
  map.put("publish_availability_caps", CommonMainString0.publish_availability_caps)
  map.put("publish_entire_batch", CommonMainString0.publish_entire_batch)
  map.put("publish_shift_request_title", CommonMainString0.publish_shift_request_title)
  map.put("range_festive_applied", CommonMainString0.range_festive_applied)
  map.put("range_festive_notice", CommonMainString0.range_festive_notice)
  map.put("rate_label_header", CommonMainString0.rate_label_header)
  map.put("rate_label_pharmacist", CommonMainString0.rate_label_pharmacist)
  map.put("rate_label_pharmacy", CommonMainString0.rate_label_pharmacy)
  map.put("received_from", CommonMainString0.received_from)
  map.put("region_label", CommonMainString0.region_label)
  map.put("region_label_caps", CommonMainString0.region_label_caps)
  map.put("region_label_short", CommonMainString0.region_label_short)
  map.put("register_button_caps", CommonMainString0.register_button_caps)
  map.put("register_title_screen", CommonMainString0.register_title_screen)
  map.put("registration_success_message", CommonMainString0.registration_success_message)
  map.put("registration_success_title", CommonMainString0.registration_success_title)
  map.put("reject_button", CommonMainString0.reject_button)
  map.put("release_shift_button", CommonMainString0.release_shift_button)
  map.put("remember_me_label", CommonMainString0.remember_me_label)
  map.put("remove_button", CommonMainString0.remove_button)
  map.put("remove_favorites", CommonMainString0.remove_favorites)
  map.put("reputation_insufficient_data", CommonMainString0.reputation_insufficient_data)
  map.put("reputation_title", CommonMainString0.reputation_title)
  map.put("reset_filters", CommonMainString0.reset_filters)
  map.put("saturday", CommonMainString0.saturday)
  map.put("save_button", CommonMainString0.save_button)
  map.put("save_changes", CommonMainString0.save_changes)
  map.put("search_pharmacies_subtitle", CommonMainString0.search_pharmacies_subtitle)
  map.put("search_pharmacies_title", CommonMainString0.search_pharmacies_title)
  map.put("search_pharmacists_title", CommonMainString0.search_pharmacists_title)
  map.put("select_at_least_one_date", CommonMainString0.select_at_least_one_date)
  map.put("select_availability_range", CommonMainString0.select_availability_range)
  map.put("select_button", CommonMainString0.select_button)
  map.put("select_dates", CommonMainString0.select_dates)
  map.put("select_language", CommonMainString0.select_language)
  map.put("select_period_title", CommonMainString0.select_period_title)
  map.put("select_role", CommonMainString0.select_role)
  map.put("select_shift_range", CommonMainString0.select_shift_range)
  map.put("selected_count_label", CommonMainString0.selected_count_label)
  map.put("send_report_button", CommonMainString0.send_report_button)
  map.put("sent_by", CommonMainString0.sent_by)
  map.put("sent_by_short", CommonMainString0.sent_by_short)
  map.put("settings_title", CommonMainString0.settings_title)
  map.put("shifts_ready_to_publish", CommonMainString0.shifts_ready_to_publish)
  map.put("single_date_caps", CommonMainString0.single_date_caps)
  map.put("skills_filter_label", CommonMainString0.skills_filter_label)
  map.put("start_label", CommonMainString0.start_label)
  map.put("status_accepted", CommonMainString0.status_accepted)
  map.put("status_accepted_caps", CommonMainString0.status_accepted_caps)
  map.put("status_cancelled", CommonMainString0.status_cancelled)
  map.put("status_confirmed", CommonMainString0.status_confirmed)
  map.put("status_in_progress", CommonMainString0.status_in_progress)
  map.put("status_proposed", CommonMainString0.status_proposed)
  map.put("status_rejected", CommonMainString0.status_rejected)
  map.put("status_waiting", CommonMainString0.status_waiting)
  map.put("storico_title", CommonMainString0.storico_title)
  map.put("sunday", CommonMainString0.sunday)
  map.put("support_alternative", CommonMainString0.support_alternative)
  map.put("support_email_body", CommonMainString0.support_email_body)
  map.put("support_email_subject", CommonMainString0.support_email_subject)
  map.put("support_feedback", CommonMainString0.support_feedback)
  map.put("support_feedback_option", CommonMainString0.support_feedback_option)
  map.put("support_intro", CommonMainString0.support_intro)
  map.put("support_message_label", CommonMainString0.support_message_label)
  map.put("support_message_placeholder", CommonMainString0.support_message_placeholder)
  map.put("support_other_option", CommonMainString0.support_other_option)
  map.put("support_report_option", CommonMainString0.support_report_option)
  map.put("support_technical_option", CommonMainString0.support_technical_option)
  map.put("support_title", CommonMainString0.support_title)
  map.put("support_type_label", CommonMainString0.support_type_label)
  map.put("surname_label", CommonMainString0.surname_label)
  map.put("surname_label_caps", CommonMainString0.surname_label_caps)
  map.put("surname_row", CommonMainString0.surname_row)
  map.put("tab_ads", CommonMainString0.tab_ads)
  map.put("tab_home", CommonMainString0.tab_home)
  map.put("tab_profile", CommonMainString0.tab_profile)
  map.put("tab_search", CommonMainString0.tab_search)
  map.put("tax_code_error_invalid", CommonMainString0.tax_code_error_invalid)
  map.put("tax_code_error_length", CommonMainString0.tax_code_error_length)
  map.put("tax_code_label", CommonMainString0.tax_code_label)
  map.put("tax_code_label_caps", CommonMainString0.tax_code_label_caps)
  map.put("tax_code_row", CommonMainString0.tax_code_row)
  map.put("thursday", CommonMainString0.thursday)
  map.put("time_active_now", CommonMainString0.time_active_now)
  map.put("time_label_header", CommonMainString0.time_label_header)
  map.put("time_remaining", CommonMainString0.time_remaining)
  map.put("total_per_shift", CommonMainString0.total_per_shift)
  map.put("tuesday", CommonMainString0.tuesday)
  map.put("type_min_chars", CommonMainString0.type_min_chars)
  map.put("user_not_logged_in", CommonMainString0.user_not_logged_in)
  map.put("vat_label_caps", CommonMainString0.vat_label_caps)
  map.put("vat_number", CommonMainString0.vat_number)
  map.put("view_in_calendar", CommonMainString0.view_in_calendar)
  map.put("waiting_counterparty", CommonMainString0.waiting_counterparty)
  map.put("waiting_final_confirmation", CommonMainString0.waiting_final_confirmation)
  map.put("wednesday", CommonMainString0.wednesday)
  map.put("welcome", CommonMainString0.welcome)
  map.put("welcome_back", CommonMainString0.welcome_back)
  map.put("yes", CommonMainString0.yes)
  map.put("yes_cancel", CommonMainString0.yes_cancel)
  map.put("your_active_ads", CommonMainString0.your_active_ads)
  map.put("your_proposal", CommonMainString0.your_proposal)
  map.put("zone_label_header", CommonMainString0.zone_label_header)
}

internal val Res.string.accept_button: StringResource
  get() = CommonMainString0.accept_button

private fun init_accept_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:accept_button", "accept_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10, 29),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    10, 33),
    )
)

internal val Res.string.accept_confirm_notice: StringResource
  get() = CommonMainString0.accept_confirm_notice

private fun init_accept_confirm_notice(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:accept_confirm_notice", "accept_confirm_notice",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    48, 133),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    52, 209),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    40, 109),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    44, 125),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    44, 121),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    44, 121),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    52, 197),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    40, 97),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    44, 113),
    )
)

internal val Res.string.accept_no_cancel_notice: StringResource
  get() = CommonMainString0.accept_no_cancel_notice

private fun init_accept_no_cancel_notice(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:accept_no_cancel_notice", "accept_no_cancel_notice",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    158, 79),
    )
)

internal val Res.string.ad_update_error: StringResource
  get() = CommonMainString0.ad_update_error

private fun init_ad_update_error(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:ad_update_error", "ad_update_error",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    182, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    262, 87),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    150, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    170, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    166, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    166, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    250, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    138, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    238, 59),
    )
)

internal val Res.string.ad_updated_success: StringResource
  get() = CommonMainString0.ad_updated_success

private fun init_ad_updated_success(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:ad_updated_success", "ad_updated_success",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    246, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    350, 110),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    190, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    230, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    230, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    218, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    318, 102),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    178, 54),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    298, 70),
    )
)

internal val Res.string.add_date_caps: StringResource
  get() = CommonMainString0.add_date_caps

private fun init_add_date_caps(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:add_date_caps", "add_date_caps",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    369, 41),
    )
)

internal val Res.string.add_favorites: StringResource
  get() = CommonMainString0.add_favorites

private fun init_add_favorites(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:add_favorites", "add_favorites",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    317, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    461, 77),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    249, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    301, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    289, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    289, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    421, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    233, 41),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    411, 49),
    )
)

internal val Res.string.add_to_batch: StringResource
  get() = CommonMainString0.add_to_batch

private fun init_add_to_batch(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:add_to_batch", "add_to_batch",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    371, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    539, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    295, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    351, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    339, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    343, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    495, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    275, 40),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    461, 44),
    )
)

internal val Res.string.address_label: StringResource
  get() = CommonMainString0.address_label

private fun init_address_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:address_label", "address_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    459, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    659, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    371, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    439, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    419, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    423, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    599, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    351, 33),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    545, 37),
    )
)

internal val Res.string.address_label_caps: StringResource
  get() = CommonMainString0.address_label_caps

private fun init_address_label_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:address_label_caps", "address_label_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    420, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    608, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    332, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    396, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    380, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    388, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    556, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    316, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    506, 38),
    )
)

internal val Res.string.address_row: StringResource
  get() = CommonMainString0.address_row

private fun init_address_row(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:address_row", "address_row",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    493, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    709, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    405, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    477, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    453, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    457, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    637, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    385, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    583, 31),
    )
)

internal val Res.string.ads_deleted: StringResource
  get() = CommonMainString0.ads_deleted

private fun init_ads_deleted(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:ads_deleted", "ads_deleted",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    525, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    753, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    437, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    513, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    485, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    485, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    673, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    413, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    615, 43),
    )
)

internal val Res.string.all_filter: StringResource
  get() = CommonMainString0.all_filter

private fun init_all_filter(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:all_filter", "all_filter",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    569, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    833, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    473, 22),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    561, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    533, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    533, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    741, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    453, 26),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    659, 26),
    )
)

internal val Res.string.already_have_account_button: StringResource
  get() = CommonMainString0.already_have_account_button

private fun init_already_have_account_button(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:already_have_account_button", "already_have_account_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    596, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    864, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    496, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    588, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    560, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    560, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    768, 91),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    480, 63),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    686, 71),
    )
)

internal val Res.string.any_period: StringResource
  get() = CommonMainString0.any_period

private fun init_any_period(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:any_period", "any_period",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    668, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    972, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    572, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    664, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    640, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    624, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    860, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    544, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    758, 42),
    )
)

internal val Res.string.app_name: StringResource
  get() = CommonMainString0.app_name

private fun init_app_name(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:app_name", "app_name",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    715, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1043, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    607, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    707, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    679, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    667, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    911, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    579, 36),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    801, 36),
    )
)

internal val Res.string.apply_button: StringResource
  get() = CommonMainString0.apply_button

private fun init_apply_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:apply_button", "apply_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    752, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1080, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    644, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    744, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    716, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    704, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    948, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    616, 28),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    838, 32),
    )
)

internal val Res.string.at_hours: StringResource
  get() = CommonMainString0.at_hours

private fun init_at_hours(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:at_hours", "at_hours",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    871, 28),
    )
)

internal val Res.string.attention: StringResource
  get() = CommonMainString0.attention

private fun init_attention(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:attention", "attention",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    785, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1125, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    673, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    777, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    749, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    737, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    993, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    645, 25),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    900, 33),
    )
)

internal val Res.string.availabilities_saved: StringResource
  get() = CommonMainString0.availabilities_saved

private fun init_availabilities_saved(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:availabilities_saved", "availabilities_saved",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    815, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1163, 112),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    703, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    807, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    779, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    767, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1035, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    671, 56),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    934, 60),
    )
)

internal val Res.string.availabilities_to_save: StringResource
  get() = CommonMainString0.availabilities_to_save

private fun init_availabilities_to_save(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:availabilities_to_save", "availabilities_to_save",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    884, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1276, 110),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    760, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    876, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    852, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    832, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1120, 98),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    728, 62),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    995, 66),
    )
)

internal val Res.string.available_shifts: StringResource
  get() = CommonMainString0.available_shifts

private fun init_available_shifts(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:available_shifts", "available_shifts",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    959, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1387, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    823, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    947, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    927, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    899, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1219, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    791, 40),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    1062, 48),
    )
)

internal val Res.string.back_nav: StringResource
  get() = CommonMainString0.back_nav

private fun init_back_nav(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:back_nav", "back_nav",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1012, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1460, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    872, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    996, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    976, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    952, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1284, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    832, 24),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    1111, 28),
    )
)

internal val Res.string.batch_availability_mgmt: StringResource
  get() = CommonMainString0.batch_availability_mgmt

private fun init_batch_availability_mgmt(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:batch_availability_mgmt", "batch_availability_mgmt",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1041, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1489, 127),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    897, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1021, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1001, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    977, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1317, 115),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    857, 59),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    1140, 75),
    )
)

internal val Res.string.batch_publish_mgmt: StringResource
  get() = CommonMainString0.batch_publish_mgmt

private fun init_batch_publish_mgmt(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:batch_publish_mgmt", "batch_publish_mgmt",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1117, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1617, 114),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    969, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1101, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1085, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1057, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1433, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    917, 50),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    1216, 70),
    )
)

internal val Res.string.batch_published_success: StringResource
  get() = CommonMainString0.batch_published_success

private fun init_batch_published_success(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:batch_published_success", "batch_published_success",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1176, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1732, 103),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1032, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1172, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1152, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1128, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1512, 91),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    968, 63),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    1287, 63),
    )
)

internal val Res.string.birth_date_label: StringResource
  get() = CommonMainString0.birth_date_label

private fun init_birth_date_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:birth_date_label", "birth_date_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1248, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1836, 104),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1096, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1244, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1204, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1196, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1604, 88),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1032, 64),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    1351, 60),
    )
)

internal val Res.string.birth_place_label: StringResource
  get() = CommonMainString0.birth_place_label

private fun init_birth_place_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:birth_place_label", "birth_place_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1309, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1941, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1157, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1313, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1273, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1265, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1693, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1097, 41),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    1412, 49),
    )
)

internal val Res.string.born_at: StringResource
  get() = CommonMainString0.born_at

private fun init_born_at(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:born_at", "born_at",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1351, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2007, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1207, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1367, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1327, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1319, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1759, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1139, 19),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    1462, 19),
    )
)

internal val Res.string.born_on: StringResource
  get() = CommonMainString0.born_on

private fun init_born_on(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:born_on", "born_on",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1371, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2031, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1227, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1387, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1347, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1339, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1779, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1159, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    1482, 27),
    )
)

internal val Res.string.call_button: StringResource
  get() = CommonMainString0.call_button

private fun init_call_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:call_button", "call_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1403, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2083, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1255, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1415, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1371, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1367, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1815, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1187, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    1510, 27),
    )
)

internal val Res.string.cancel_button: StringResource
  get() = CommonMainString0.cancel_button

private fun init_cancel_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:cancel_button", "cancel_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1435, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2119, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1283, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1443, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1403, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1395, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1859, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1215, 29),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    1538, 33),
    )
)

internal val Res.string.cancel_match_button: StringResource
  get() = CommonMainString0.cancel_match_button

private fun init_cancel_match_button(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:cancel_match_button", "cancel_match_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1469, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2161, 87),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1313, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1477, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1437, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1429, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1897, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1245, 59),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    1572, 55),
    )
)

internal val Res.string.cancel_match_confirm_msg: StringResource
  get() = CommonMainString0.cancel_match_confirm_msg

private fun init_cancel_match_confirm_msg(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:cancel_match_confirm_msg", "cancel_match_confirm_msg",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    1628, 72),
    )
)

internal val Res.string.cap_label: StringResource
  get() = CommonMainString0.cap_label

private fun init_cap_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:cap_label", "cap_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1557, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2281, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1397, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1565, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1537, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1525, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2017, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1337, 29),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    1729, 25),
    )
)

internal val Res.string.cap_label_short: StringResource
  get() = CommonMainString0.cap_label_short

private fun init_cap_label_short(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:cap_label_short", "cap_label_short",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1529, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2249, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1369, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1537, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1497, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1489, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1977, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1305, 31),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    1701, 27),
    )
)

internal val Res.string.citizenship_label: StringResource
  get() = CommonMainString0.citizenship_label

private fun init_citizenship_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:citizenship_label", "citizenship_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1642, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2362, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1478, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1654, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1622, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1618, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2142, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1406, 37),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    1802, 45),
    )
)

internal val Res.string.citizenship_label_caps: StringResource
  get() = CommonMainString0.citizenship_label_caps

private fun init_citizenship_label_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:citizenship_label_caps", "citizenship_label_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1583, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2307, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1431, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1607, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1575, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1567, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2079, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1367, 38),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    1755, 46),
    )
)

internal val Res.string.city_label: StringResource
  get() = CommonMainString0.city_label

private fun init_city_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:city_label", "city_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1733, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2457, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1557, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1737, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1701, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1701, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2241, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1477, 30),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    1881, 30),
    )
)

internal val Res.string.city_label_short: StringResource
  get() = CommonMainString0.city_label_short

private fun init_city_label_short(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:city_label_short", "city_label_short",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1700, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2416, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1524, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1700, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1668, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1664, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2200, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1444, 32),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    1848, 32),
    )
)

internal val Res.string.city_row: StringResource
  get() = CommonMainString0.city_row

private fun init_city_row(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:city_row", "city_row",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1764, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2492, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1584, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1768, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1732, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1732, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2276, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1508, 24),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    1912, 24),
    )
)

internal val Res.string.city_zone_label: StringResource
  get() = CommonMainString0.city_zone_label

private fun init_city_zone_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:city_zone_label", "city_zone_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1789, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2521, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1609, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1793, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1757, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1757, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2309, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1533, 63),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    1937, 79),
    )
)

internal val Res.string.city_zone_placeholder: StringResource
  get() = CommonMainString0.city_zone_placeholder

private fun init_city_zone_placeholder(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:city_zone_placeholder", "city_zone_placeholder",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1845, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2629, 101),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1677, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1869, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1813, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1833, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2417, 101),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1597, 61),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    2017, 73),
    )
)

internal val Res.string.clear_all_caps: StringResource
  get() = CommonMainString0.clear_all_caps

private fun init_clear_all_caps(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:clear_all_caps", "clear_all_caps",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    2091, 42),
    )
)

internal val Res.string.close_button: StringResource
  get() = CommonMainString0.close_button

private fun init_close_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:close_button", "close_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1891, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2731, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1743, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1939, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1855, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1903, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2519, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1659, 28),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    2134, 28),
    )
)

internal val Res.string.configure_shift_range: StringResource
  get() = CommonMainString0.configure_shift_range

private fun init_configure_shift_range(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:configure_shift_range", "configure_shift_range",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1928, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2776, 85),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1772, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1968, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1884, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1932, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2560, 93),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1688, 57),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    2163, 57),
    )
)

internal val Res.string.confirm_acceptance: StringResource
  get() = CommonMainString0.confirm_acceptance

private fun init_confirm_acceptance(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:confirm_acceptance", "confirm_acceptance",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1998, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2862, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1830, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2030, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1946, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1994, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2654, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1746, 42),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    2221, 54),
    )
)

internal val Res.string.confirm_action: StringResource
  get() = CommonMainString0.confirm_action

private fun init_confirm_action(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:confirm_action", "confirm_action",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2053, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2941, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1881, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2085, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2001, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2049, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2733, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1789, 30),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    2276, 34),
    )
)

internal val Res.string.confirm_all_availabilities: StringResource
  get() = CommonMainString0.confirm_all_availabilities

private fun init_confirm_all_availabilities(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:confirm_all_availabilities", "confirm_all_availabilities",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2092, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2996, 134),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1916, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2120, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2036, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2084, 90),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2788, 82),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1820, 74),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    2311, 86),
    )
)

internal val Res.string.confirm_caps: StringResource
  get() = CommonMainString0.confirm_caps

private fun init_confirm_caps(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:confirm_caps", "confirm_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2159, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    3131, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1995, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2187, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2099, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2175, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2871, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1895, 28),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    2398, 32),
    )
)

internal val Res.string.confirm_notice_final: StringResource
  get() = CommonMainString0.confirm_notice_final

private fun init_confirm_notice_final(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:confirm_notice_final", "confirm_notice_final",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2196, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    3184, 316),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2028, 148),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2220, 168),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2132, 88),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2208, 180),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2924, 272),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1924, 144),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    2431, 160),
    )
)

internal val Res.string.confirm_now_button: StringResource
  get() = CommonMainString0.confirm_now_button

private fun init_confirm_now_button(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:confirm_now_button", "confirm_now_button",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    2592, 42),
    )
)

internal val Res.string.confirm_operation: StringResource
  get() = CommonMainString0.confirm_operation

private fun init_confirm_operation(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:confirm_operation", "confirm_operation",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    2635, 53),
    )
)

internal val Res.string.contact_body: StringResource
  get() = CommonMainString0.contact_body

private fun init_contact_body(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:contact_body", "contact_body",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2281, 144),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    3501, 232),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2177, 128),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2389, 144),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2221, 140),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2389, 140),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3197, 232),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2069, 120),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    2689, 128),
    )
)

internal val Res.string.contact_subject: StringResource
  get() = CommonMainString0.contact_subject

private fun init_contact_subject(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:contact_subject", "contact_subject",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2426, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    3734, 87),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2306, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2534, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2362, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2530, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3430, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2190, 67),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    2818, 59),
    )
)

internal val Res.string.contacts: StringResource
  get() = CommonMainString0.contacts

private fun init_contacts(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:contacts", "contacts",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2486, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    3822, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2366, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2598, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2422, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2590, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3502, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2258, 32),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    2878, 28),
    )
)

internal val Res.string.counterparty_accepted: StringResource
  get() = CommonMainString0.counterparty_accepted

private fun init_counterparty_accepted(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:counterparty_accepted", "counterparty_accepted",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2515, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    3855, 213),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2395, 97),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2627, 121),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2451, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2619, 105),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3543, 169),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2291, 85),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    2907, 109),
    )
)

internal val Res.string.data_festive_label: StringResource
  get() = CommonMainString0.data_festive_label

private fun init_data_festive_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:data_festive_label", "data_festive_label",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    3017, 58),
    )
)

internal val Res.string.date_label_header: StringResource
  get() = CommonMainString0.date_label_header

private fun init_date_label_header(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:date_label_header", "date_label_header",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2585, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4069, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2493, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2749, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2521, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2725, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3713, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2377, 33),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    3076, 33),
    )
)

internal val Res.string.degree_label_caps: StringResource
  get() = CommonMainString0.degree_label_caps

private fun init_degree_label_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:degree_label_caps", "degree_label_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2619, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4123, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2527, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2783, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2555, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2759, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3751, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2411, 33),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    3110, 45),
    )
)

internal val Res.string.delete_ads_confirm_msg: StringResource
  get() = CommonMainString0.delete_ads_confirm_msg

private fun init_delete_ads_confirm_msg(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:delete_ads_confirm_msg", "delete_ads_confirm_msg",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    3156, 154),
    )
)

internal val Res.string.delete_ads_title: StringResource
  get() = CommonMainString0.delete_ads_title

private fun init_delete_ads_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:delete_ads_title", "delete_ads_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    3311, 44),
    )
)

internal val Res.string.delete_button_caps: StringResource
  get() = CommonMainString0.delete_button_caps

private fun init_delete_button_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:delete_button_caps", "delete_button_caps",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    3356, 38),
    )
)

internal val Res.string.delete_label: StringResource
  get() = CommonMainString0.delete_label

private fun init_delete_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:delete_label", "delete_label",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    3395, 32),
    )
)

internal val Res.string.delete_notification_msg: StringResource
  get() = CommonMainString0.delete_notification_msg

private fun init_delete_notification_msg(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:delete_notification_msg", "delete_notification_msg",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    3428, 83),
    )
)

internal val Res.string.delete_notification_title: StringResource
  get() = CommonMainString0.delete_notification_title

private fun init_delete_notification_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:delete_notification_title", "delete_notification_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    3512, 57),
    )
)

internal val Res.string.delete_selected: StringResource
  get() = CommonMainString0.delete_selected

private fun init_delete_selected(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:delete_selected", "delete_selected",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2657, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4169, 87),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2561, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2821, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2593, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2805, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3809, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2445, 51),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    3570, 59),
    )
)

internal val Res.string.description: StringResource
  get() = CommonMainString0.description

private fun init_description(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:description", "description",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2721, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4257, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2617, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2885, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2653, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2869, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3889, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2497, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    3630, 35),
    )
)

internal val Res.string.digital_signature: StringResource
  get() = CommonMainString0.digital_signature

private fun init_digital_signature(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:digital_signature", "digital_signature",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2757, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4301, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2653, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2921, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2689, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2905, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3933, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2525, 41),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    3666, 45),
    )
)

internal val Res.string.director_registration_label: StringResource
  get() = CommonMainString0.director_registration_label

private fun init_director_registration_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:director_registration_label", "director_registration_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2703, 67),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    3712, 79),
    )
)

internal val Res.string.discount_active_badge: StringResource
  get() = CommonMainString0.discount_active_badge

private fun init_discount_active_badge(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:discount_active_badge", "discount_active_badge",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2807, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4371, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2771, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2967, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2743, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2955, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4003, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2567, 53),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    3792, 53),
    )
)

internal val Res.string.discount_progress_label: StringResource
  get() = CommonMainString0.discount_progress_label

private fun init_discount_progress_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:discount_progress_label", "discount_progress_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2857, 123),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4441, 175),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2825, 103),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3025, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2797, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3009, 103),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4073, 171),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2621, 99),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    3846, 103),
    )
)

internal val Res.string.disdici_button: StringResource
  get() = CommonMainString0.disdici_button

private fun init_disdici_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:disdici_button", "disdici_button",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    3950, 34),
    )
)

internal val Res.string.edit_ad_title: StringResource
  get() = CommonMainString0.edit_ad_title

private fun init_edit_ad_title(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:edit_ad_title", "edit_ad_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2981, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4617, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2929, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3133, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2905, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3113, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4245, 85),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2721, 37),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    3985, 45),
    )
)

internal val Res.string.edit_data_pharmacy: StringResource
  get() = CommonMainString0.edit_data_pharmacy

private fun init_edit_data_pharmacy(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:edit_data_pharmacy", "edit_data_pharmacy",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3027, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4691, 110),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2963, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3175, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2951, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3155, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4331, 82),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2759, 50),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    4031, 58),
    )
)

internal val Res.string.edit_data_professional: StringResource
  get() = CommonMainString0.edit_data_professional

private fun init_edit_data_professional(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:edit_data_professional", "edit_data_professional",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3090, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4802, 114),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3014, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3230, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3014, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3214, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4414, 86),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2810, 54),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    4090, 62),
    )
)

internal val Res.string.edit_label: StringResource
  get() = CommonMainString0.edit_label

private fun init_edit_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:edit_label", "edit_label",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    4153, 30),
    )
)

internal val Res.string.edit_profile: StringResource
  get() = CommonMainString0.edit_profile

private fun init_edit_profile(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:edit_profile", "edit_profile",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3149, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4917, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3069, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3293, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3085, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3273, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4501, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2865, 44),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    4184, 44),
    )
)

internal val Res.string.email_button: StringResource
  get() = CommonMainString0.email_button

private fun init_email_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:email_button", "email_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3194, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4986, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3106, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3334, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3130, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3314, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4578, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2910, 36),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    4229, 28),
    )
)

internal val Res.string.email_label: StringResource
  get() = CommonMainString0.email_label

private fun init_email_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:email_label", "email_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3223, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5015, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3135, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3363, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3159, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3343, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4607, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2947, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    4258, 27),
    )
)

internal val Res.string.email_placeholder: StringResource
  get() = CommonMainString0.email_placeholder

private fun init_email_placeholder(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:email_placeholder", "email_placeholder",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3251, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5043, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3163, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3411, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3187, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3371, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4671, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2983, 49),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    4286, 45),
    )
)

internal val Res.string.email_row: StringResource
  get() = CommonMainString0.email_row

private fun init_email_row(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:email_row", "email_row",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3301, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5109, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3213, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3457, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3233, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3421, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4717, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3033, 33),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    4332, 25),
    )
)

internal val Res.string.emergency_accepted_notice: StringResource
  get() = CommonMainString0.emergency_accepted_notice

private fun init_emergency_accepted_notice(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:emergency_accepted_notice", "emergency_accepted_notice",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    4358, 157),
    )
)

internal val Res.string.emergency_cancel_blocked_label: StringResource
  get() = CommonMainString0.emergency_cancel_blocked_label

private fun init_emergency_cancel_blocked_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:emergency_cancel_blocked_label", "emergency_cancel_blocked_label",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    4516, 62),
    )
)

internal val Res.string.emergency_cancel_blocked_msg: StringResource
  get() = CommonMainString0.emergency_cancel_blocked_msg

private fun init_emergency_cancel_blocked_msg(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:emergency_cancel_blocked_msg", "emergency_cancel_blocked_msg",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    4579, 244),
    )
)

internal val Res.string.emergency_click_for_details: StringResource
  get() = CommonMainString0.emergency_click_for_details

private fun init_emergency_click_for_details(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:emergency_click_for_details", "emergency_click_for_details",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    4824, 75),
    )
)

internal val Res.string.emergency_confirm_now: StringResource
  get() = CommonMainString0.emergency_confirm_now

private fun init_emergency_confirm_now(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:emergency_confirm_now", "emergency_confirm_now",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    4900, 53),
    )
)

internal val Res.string.emergency_counterparty_accepted: StringResource
  get() = CommonMainString0.emergency_counterparty_accepted

private fun init_emergency_counterparty_accepted(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:emergency_counterparty_accepted", "emergency_counterparty_accepted",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    4954, 91),
    )
)

internal val Res.string.emergency_immediate_matching: StringResource
  get() = CommonMainString0.emergency_immediate_matching

private fun init_emergency_immediate_matching(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:emergency_immediate_matching", "emergency_immediate_matching",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    5046, 60),
    )
)

internal val Res.string.emergency_label: StringResource
  get() = CommonMainString0.emergency_label

private fun init_emergency_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:emergency_label", "emergency_label",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    5107, 63),
    )
)

internal val Res.string.emergency_urgent_request: StringResource
  get() = CommonMainString0.emergency_urgent_request

private fun init_emergency_urgent_request(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:emergency_urgent_request", "emergency_urgent_request",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    5171, 56),
    )
)

internal val Res.string.end_label: StringResource
  get() = CommonMainString0.end_label

private fun init_end_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:end_label", "end_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3327, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5135, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3239, 21),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3483, 21),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3259, 21),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3447, 21),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4743, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3067, 25),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    5228, 25),
    )
)

internal val Res.string.error_or_duplicates: StringResource
  get() = CommonMainString0.error_or_duplicates

private fun init_error_or_duplicates(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:error_or_duplicates", "error_or_duplicates",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3353, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5165, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3261, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3505, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3281, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3469, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4777, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3093, 47),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    5254, 51),
    )
)

internal val Res.string.error_sending: StringResource
  get() = CommonMainString0.error_sending

private fun init_error_sending(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:error_sending", "error_sending",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3409, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5241, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3317, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3557, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3333, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3521, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4857, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3141, 41),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    5306, 53),
    )
)

internal val Res.string.exit_app_confirm: StringResource
  get() = CommonMainString0.exit_app_confirm

private fun init_exit_app_confirm(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:exit_app_confirm", "exit_app_confirm",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3367, 76),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    5360, 88),
    )
)

internal val Res.string.exit_app_title: StringResource
  get() = CommonMainString0.exit_app_title

private fun init_exit_app_title(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:exit_app_title", "exit_app_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3444, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    5449, 42),
    )
)

internal val Res.string.farmacia: StringResource
  get() = CommonMainString0.farmacia

private fun init_farmacia(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:farmacia", "farmacia",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3455, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5323, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3479, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3611, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3387, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3571, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4927, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3183, 28),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    5492, 28),
    )
)

internal val Res.string.farmacista: StringResource
  get() = CommonMainString0.farmacista

private fun init_farmacista(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:farmacista", "farmacista",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3484, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5364, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3508, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3640, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3416, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3600, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4960, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3212, 26),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    5521, 34),
    )
)

internal val Res.string.female_gender: StringResource
  get() = CommonMainString0.female_gender

private fun init_female_gender(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:female_gender", "female_gender",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3515, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5415, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3543, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3679, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3451, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3639, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5003, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3239, 25),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    5556, 25),
    )
)

internal val Res.string.festive_notice_banner: StringResource
  get() = CommonMainString0.festive_notice_banner

private fun init_festive_notice_banner(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:festive_notice_banner", "festive_notice_banner",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    5582, 101),
    )
)

internal val Res.string.filter_label: StringResource
  get() = CommonMainString0.filter_label

private fun init_filter_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:filter_label", "filter_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3569, 32),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    5684, 28),
    )
)

internal val Res.string.filter_show_only: StringResource
  get() = CommonMainString0.filter_show_only

private fun init_filter_show_only(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:filter_show_only", "filter_show_only",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3541, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5441, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3602, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3705, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3477, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3665, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5029, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3265, 40),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    5713, 40),
    )
)

internal val Res.string.final_confirmation: StringResource
  get() = CommonMainString0.final_confirmation

private fun init_final_confirmation(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:final_confirmation", "final_confirmation",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3586, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5502, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3643, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3750, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3530, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3710, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5094, 98),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3306, 42),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    5754, 54),
    )
)

internal val Res.string.final_logout: StringResource
  get() = CommonMainString0.final_logout

private fun init_final_logout(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:final_logout", "final_logout",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3645, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5581, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3694, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3809, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3589, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3769, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5193, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3349, 36),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    5809, 44),
    )
)

internal val Res.string.friday: StringResource
  get() = CommonMainString0.friday

private fun init_friday(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:friday", "friday",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3690, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5654, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3731, 22),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3850, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3638, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3814, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5258, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3386, 26),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    5854, 26),
    )
)

internal val Res.string.from_label: StringResource
  get() = CommonMainString0.from_label

private fun init_from_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:from_label", "from_label",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    5881, 30),
    )
)

internal val Res.string.gender_label: StringResource
  get() = CommonMainString0.gender_label

private fun init_gender_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:gender_label", "gender_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3759, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5731, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3788, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3911, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3699, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3879, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5327, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3447, 32),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    5946, 32),
    )
)

internal val Res.string.gender_label_caps: StringResource
  get() = CommonMainString0.gender_label_caps

private fun init_gender_label_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:gender_label_caps", "gender_label_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3717, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5693, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3754, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3877, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3665, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3845, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5293, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3413, 33),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    5912, 33),
    )
)

internal val Res.string.generate_shifts_caps: StringResource
  get() = CommonMainString0.generate_shifts_caps

private fun init_generate_shifts_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:generate_shifts_caps", "generate_shifts_caps",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    5979, 44),
    )
)

internal val Res.string.go_to_login: StringResource
  get() = CommonMainString0.go_to_login

private fun init_go_to_login(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:go_to_login", "go_to_login",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3796, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5768, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3821, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3940, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3728, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3908, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5360, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3480, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    6024, 35),
    )
)

internal val Res.string.got_it: StringResource
  get() = CommonMainString0.got_it

private fun init_got_it(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:got_it", "got_it",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3828, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5840, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3857, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3976, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3768, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3948, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5420, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3516, 42),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    6060, 42),
    )
)

internal val Res.string.home_stats_accepted: StringResource
  get() = CommonMainString0.home_stats_accepted

private fun init_home_stats_accepted(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:home_stats_accepted", "home_stats_accepted",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3879, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5907, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3900, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4019, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3811, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3991, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5479, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3559, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    6103, 39),
    )
)

internal val Res.string.home_stats_confirmed: StringResource
  get() = CommonMainString0.home_stats_confirmed

private fun init_home_stats_confirmed(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:home_stats_confirmed", "home_stats_confirmed",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3923, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5959, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3940, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4059, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3855, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4031, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5527, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3599, 40),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    6143, 44),
    )
)

internal val Res.string.home_stats_proposed: StringResource
  get() = CommonMainString0.home_stats_proposed

private fun init_home_stats_proposed(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:home_stats_proposed", "home_stats_proposed",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3968, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6024, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3981, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4104, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3900, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4076, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5588, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3640, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    6188, 39),
    )
)

internal val Res.string.home_stats_to_confirm: StringResource
  get() = CommonMainString0.home_stats_to_confirm

private fun init_home_stats_to_confirm(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:home_stats_to_confirm", "home_stats_to_confirm",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4021, 45),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    6228, 49),
    )
)

internal val Res.string.hourly_rate_label: StringResource
  get() = CommonMainString0.hourly_rate_label

private fun init_hourly_rate_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:hourly_rate_label", "hourly_rate_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4016, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6076, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4067, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4148, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3944, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4116, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5644, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3680, 45),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    6278, 57),
    )
)

internal val Res.string.how_can_we_help: StringResource
  get() = CommonMainString0.how_can_we_help

private fun init_how_can_we_help(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:how_can_we_help", "how_can_we_help",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4070, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6150, 99),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4121, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4206, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3998, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4174, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5726, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3726, 55),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    6336, 55),
    )
)

internal val Res.string.identity_header: StringResource
  get() = CommonMainString0.identity_header

private fun init_identity_header(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:identity_header", "identity_header",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4126, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6250, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4173, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4266, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4066, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4226, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5810, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3782, 51),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    6392, 55),
    )
)

internal val Res.string.in_evaluation: StringResource
  get() = CommonMainString0.in_evaluation

private fun init_in_evaluation(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:in_evaluation", "in_evaluation",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    6448, 45),
    )
)

internal val Res.string.include_only_label: StringResource
  get() = CommonMainString0.include_only_label

private fun init_include_only_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:include_only_label", "include_only_label",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    6494, 46),
    )
)

internal val Res.string.inconsistent_data: StringResource
  get() = CommonMainString0.inconsistent_data

private fun init_inconsistent_data(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:inconsistent_data", "inconsistent_data",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4186, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6306, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4229, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4322, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4122, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4282, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5866, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3834, 45),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    6541, 45),
    )
)

internal val Res.string.interval_caps: StringResource
  get() = CommonMainString0.interval_caps

private fun init_interval_caps(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:interval_caps", "interval_caps",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    6587, 33),
    )
)

internal val Res.string.invalid_email: StringResource
  get() = CommonMainString0.invalid_email

private fun init_invalid_email(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:invalid_email", "invalid_email",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4240, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6376, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4279, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4372, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4180, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4336, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5948, 77),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3880, 53),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    6621, 53),
    )
)

internal val Res.string.language_chinese: StringResource
  get() = CommonMainString0.language_chinese

private fun init_language_chinese(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:language_chinese", "language_chinese",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4298, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6446, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4329, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4434, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4234, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4394, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6026, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3934, 32),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    6675, 32),
    )
)

internal val Res.string.language_english: StringResource
  get() = CommonMainString0.language_english

private fun init_language_english(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:language_english", "language_english",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4339, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6495, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4366, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4467, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4271, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4431, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6075, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3967, 32),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    6708, 36),
    )
)

internal val Res.string.language_french: StringResource
  get() = CommonMainString0.language_french

private fun init_language_french(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:language_french", "language_french",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4376, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6540, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4403, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4504, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4308, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4468, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6128, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4000, 31),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    6745, 35),
    )
)

internal val Res.string.language_german: StringResource
  get() = CommonMainString0.language_german

private fun init_language_german(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:language_german", "language_german",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4416, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6584, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4435, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4540, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4344, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4504, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6184, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4032, 31),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    6781, 35),
    )
)

internal val Res.string.language_greek: StringResource
  get() = CommonMainString0.language_greek

private fun init_language_greek(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:language_greek", "language_greek",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4452, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6632, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4467, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4576, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4380, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4540, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6232, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4064, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    6817, 30),
    )
)

internal val Res.string.language_italian: StringResource
  get() = CommonMainString0.language_italian

private fun init_language_italian(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:language_italian", "language_italian",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4491, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6679, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4498, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4607, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4411, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4571, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6279, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4099, 40),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    6848, 36),
    )
)

internal val Res.string.language_portuguese: StringResource
  get() = CommonMainString0.language_portuguese

private fun init_language_portuguese(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:language_portuguese", "language_portuguese",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4532, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6724, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4535, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4644, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4448, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4608, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6336, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4140, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    6885, 43),
    )
)

internal val Res.string.language_selector: StringResource
  get() = CommonMainString0.language_selector

private fun init_language_selector(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:language_selector", "language_selector",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4580, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6784, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4579, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4688, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4488, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4652, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6400, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4184, 41),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    6929, 53),
    )
)

internal val Res.string.language_spanish: StringResource
  get() = CommonMainString0.language_spanish

private fun init_language_spanish(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:language_spanish", "language_spanish",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4622, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6854, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4621, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4746, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4546, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4706, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6466, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4226, 40),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    6983, 36),
    )
)

internal val Res.string.loading: StringResource
  get() = CommonMainString0.loading

private fun init_loading(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:loading", "loading",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4659, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6903, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4658, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4783, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4583, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4743, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6515, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4267, 31),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    7020, 35),
    )
)

internal val Res.string.location_contacts: StringResource
  get() = CommonMainString0.location_contacts

private fun init_location_contacts(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:location_contacts", "location_contacts",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4687, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6943, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4690, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4815, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4619, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4779, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6559, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4299, 53),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    7056, 45),
    )
)

internal val Res.string.login_button: StringResource
  get() = CommonMainString0.login_button

private fun init_login_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:login_button", "login_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4741, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7009, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4744, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4865, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4669, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4829, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6625, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4353, 28),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    7102, 28),
    )
)

internal val Res.string.login_subtitle: StringResource
  get() = CommonMainString0.login_subtitle

private fun init_login_subtitle(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:login_subtitle", "login_subtitle",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4774, 86),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7050, 118),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4773, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4898, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4706, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4858, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6662, 110),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4382, 54),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    7131, 66),
    )
)

internal val Res.string.login_title: StringResource
  get() = CommonMainString0.login_title

private fun init_login_title(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:login_title", "login_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4861, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7169, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4836, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4961, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4777, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4921, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6773, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4437, 47),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    7198, 51),
    )
)

internal val Res.string.male_gender: StringResource
  get() = CommonMainString0.male_gender

private fun init_male_gender(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:male_gender", "male_gender",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4917, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7237, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4888, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5013, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4837, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4973, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6833, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4485, 23),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    7250, 23),
    )
)

internal val Res.string.manage_availability_title: StringResource
  get() = CommonMainString0.manage_availability_title

private fun init_manage_availability_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:manage_availability_title", "manage_availability_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4941, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7261, 101),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4912, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5037, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4861, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4997, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6857, 93),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4509, 53),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    7274, 65),
    )
)

internal val Res.string.mandatory_fields_notice: StringResource
  get() = CommonMainString0.mandatory_fields_notice

private fun init_mandatory_fields_notice(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:mandatory_fields_notice", "mandatory_fields_notice",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5011, 103),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7363, 167),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4974, 99),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5103, 119),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4927, 111),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5067, 119),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6951, 171),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4563, 99),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    7340, 107),
    )
)

internal val Res.string.matching_title: StringResource
  get() = CommonMainString0.matching_title

private fun init_matching_title(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:matching_title", "matching_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5115, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7531, 102),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5074, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5223, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5039, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5187, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7123, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4663, 42),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    7448, 54),
    )
)

internal val Res.string.monday: StringResource
  get() = CommonMainString0.monday

private fun init_monday(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:monday", "monday",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5170, 22),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7634, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5129, 22),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5286, 22),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5094, 22),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5254, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7186, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4706, 26),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    7503, 26),
    )
)

internal val Res.string.my_favorites: StringResource
  get() = CommonMainString0.my_favorites

private fun init_my_favorites(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:my_favorites", "my_favorites",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5240, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7736, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5195, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5356, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5160, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5336, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7296, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4776, 36),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    7581, 44),
    )
)

internal val Res.string.my_favorites_title: StringResource
  get() = CommonMainString0.my_favorites_title

private fun init_my_favorites_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:my_favorites_title", "my_favorites_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5193, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7669, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5152, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5309, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5117, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5289, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7233, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4733, 42),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    7530, 50),
    )
)

internal val Res.string.name_label: StringResource
  get() = CommonMainString0.name_label

private fun init_name_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:name_label", "name_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5317, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7837, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5264, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5429, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5233, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5409, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7385, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4845, 26),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    7658, 26),
    )
)

internal val Res.string.name_label_caps: StringResource
  get() = CommonMainString0.name_label_caps

private fun init_name_label_caps(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:name_label_caps", "name_label_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5281, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7797, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5232, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5397, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5197, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5377, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7353, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4813, 31),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    7626, 31),
    )
)

internal val Res.string.name_row: StringResource
  get() = CommonMainString0.name_row

private fun init_name_row(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:name_row", "name_row",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5348, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7872, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5299, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5456, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5264, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5436, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7412, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4872, 24),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    7685, 24),
    )
)

internal val Res.string.new_total: StringResource
  get() = CommonMainString0.new_total

private fun init_new_total(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:new_total", "new_total",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5377, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7905, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5324, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5481, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5293, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5461, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7437, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4897, 29),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    7710, 33),
    )
)

internal val Res.string.no: StringResource
  get() = CommonMainString0.no

private fun init_no(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:no", "no",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6097, 14),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    8612, 14),
    )
)

internal val Res.string.no_account_button: StringResource
  get() = CommonMainString0.no_account_button

private fun init_no_account_button(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:no_account_button", "no_account_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5419, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7951, 105),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5354, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5515, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5331, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5495, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7483, 105),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4927, 53),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    7744, 65),
    )
)

internal val Res.string.no_ads_inserted: StringResource
  get() = CommonMainString0.no_ads_inserted

private fun init_no_ads_inserted(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:no_ads_inserted", "no_ads_inserted",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5485, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    8057, 111),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5424, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5585, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5393, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5557, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7589, 91),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4981, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    7810, 55),
    )
)

internal val Res.string.no_applications_received: StringResource
  get() = CommonMainString0.no_applications_received

private fun init_no_applications_received(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:no_applications_received", "no_applications_received",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5545, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    8169, 148),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5468, 88),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5649, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5449, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5613, 96),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7681, 120),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5025, 68),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    7866, 92),
    )
)

internal val Res.string.no_available_shifts: StringResource
  get() = CommonMainString0.no_available_shifts

private fun init_no_available_shifts(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:no_available_shifts", "no_available_shifts",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5614, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    8318, 115),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5557, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5726, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5518, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5710, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7802, 111),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5094, 63),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    7959, 67),
    )
)

internal val Res.string.no_favorites_subtitle: StringResource
  get() = CommonMainString0.no_favorites_subtitle

private fun init_no_favorites_subtitle(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:no_favorites_subtitle", "no_favorites_subtitle",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5686, 101),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    8434, 181),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5625, 101),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5802, 109),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5594, 93),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5778, 121),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7914, 173),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5158, 93),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    8027, 97),
    )
)

internal val Res.string.no_favorites_yet: StringResource
  get() = CommonMainString0.no_favorites_yet

private fun init_no_favorites_yet(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:no_favorites_yet", "no_favorites_yet",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5788, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    8616, 112),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5727, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5912, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5688, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5900, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8088, 96),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5252, 52),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    8125, 68),
    )
)

internal val Res.string.no_matches_active: StringResource
  get() = CommonMainString0.no_matches_active

private fun init_no_matches_active(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:no_matches_active", "no_matches_active",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5857, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    8729, 125),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5800, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5977, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5741, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5965, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8185, 117),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5305, 61),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    8194, 65),
    )
)

internal val Res.string.no_message: StringResource
  get() = CommonMainString0.no_message

private fun init_no_message(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:no_message", "no_message",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5923, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    8855, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5870, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6043, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5791, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6047, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8303, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5367, 30),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    8260, 42),
    )
)

internal val Res.string.no_new_notifications: StringResource
  get() = CommonMainString0.no_new_notifications

private fun init_no_new_notifications(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:no_new_notifications", "no_new_notifications",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    8303, 60),
    )
)

internal val Res.string.no_pharmacies_found: StringResource
  get() = CommonMainString0.no_pharmacies_found

private fun init_no_pharmacies_found(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:no_pharmacies_found", "no_pharmacies_found",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5962, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    8910, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5905, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6078, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5830, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6090, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8358, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5398, 47),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    8364, 59),
    )
)

internal val Res.string.no_pharmacists_found: StringResource
  get() = CommonMainString0.no_pharmacists_found

private fun init_no_pharmacists_found(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:no_pharmacists_found", "no_pharmacists_found",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6022, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    8994, 92),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5961, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6142, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5894, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6158, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8430, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5446, 52),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    8424, 64),
    )
)

internal val Res.string.nominative_label: StringResource
  get() = CommonMainString0.nominative_label

private fun init_nominative_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:nominative_label", "nominative_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6083, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9087, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6018, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6215, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5955, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6231, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8507, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5499, 32),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    8489, 40),
    )
)

internal val Res.string.not_specified: StringResource
  get() = CommonMainString0.not_specified

private fun init_not_specified(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:not_specified", "not_specified",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6136, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9148, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6055, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6260, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5996, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6264, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8540, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5532, 33),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    8530, 41),
    )
)

internal val Res.string.notifications_title: StringResource
  get() = CommonMainString0.notifications_title

private fun init_notifications_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:notifications_title", "notifications_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    8572, 39),
    )
)

internal val Res.string.official_profile: StringResource
  get() = CommonMainString0.official_profile

private fun init_official_profile(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:official_profile", "official_profile",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6178, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9218, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6112, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6302, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6038, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6310, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8590, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5566, 40),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    8627, 48),
    )
)

internal val Res.string.ok_button: StringResource
  get() = CommonMainString0.ok_button

private fun init_ok_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:ok_button", "ok_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6227, 21),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9279, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6161, 21),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6347, 21),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6083, 21),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6355, 21),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8667, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5607, 25),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    8676, 21),
    )
)

internal val Res.string.operating_area_title: StringResource
  get() = CommonMainString0.operating_area_title

private fun init_operating_area_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:operating_area_title", "operating_area_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6183, 72),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    8698, 84),
    )
)

internal val Res.string.operating_cap_label_caps: StringResource
  get() = CommonMainString0.operating_cap_label_caps

private fun init_operating_cap_label_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:operating_cap_label_caps", "operating_cap_label_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6249, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9317, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6256, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6369, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6105, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6377, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8693, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5633, 48),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    8783, 44),
    )
)

internal val Res.string.operating_city_label_caps: StringResource
  get() = CommonMainString0.operating_city_label_caps

private fun init_operating_city_label_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:operating_city_label_caps", "operating_city_label_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6294, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9366, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6301, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6410, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6146, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6422, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8754, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5682, 49),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    8828, 49),
    )
)

internal val Res.string.order_registration_label: StringResource
  get() = CommonMainString0.order_registration_label

private fun init_order_registration_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:order_registration_label", "order_registration_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6347, 60),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    8878, 64),
    )
)

internal val Res.string.password_label: StringResource
  get() = CommonMainString0.password_label

private fun init_password_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:password_label", "password_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6340, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9424, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6408, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6464, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6192, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6468, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8812, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5732, 30),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    8943, 34),
    )
)

internal val Res.string.pharmacist_details_title: StringResource
  get() = CommonMainString0.pharmacist_details_title

private fun init_pharmacist_details_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:pharmacist_details_title", "pharmacist_details_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6375, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9467, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6443, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6503, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6231, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6511, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8851, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5763, 52),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    8978, 56),
    )
)

internal val Res.string.pharmacist_name_label: StringResource
  get() = CommonMainString0.pharmacist_name_label

private fun init_pharmacist_name_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:pharmacist_name_label", "pharmacist_name_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6428, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9552, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6500, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6564, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6288, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6576, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8936, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5816, 49),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    9035, 49),
    )
)

internal val Res.string.pharmacists_needed: StringResource
  get() = CommonMainString0.pharmacists_needed

private fun init_pharmacists_needed(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:pharmacists_needed", "pharmacists_needed",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6482, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9622, 138),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6554, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6618, 82),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6338, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6626, 86),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9006, 86),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5866, 70),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    9085, 78),
    )
)

internal val Res.string.pharmacy_city_label: StringResource
  get() = CommonMainString0.pharmacy_city_label

private fun init_pharmacy_city_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:pharmacy_city_label", "pharmacy_city_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6561, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9761, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6625, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6701, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6417, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6713, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9093, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5937, 51),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    9164, 55),
    )
)

internal val Res.string.pharmacy_city_placeholder: StringResource
  get() = CommonMainString0.pharmacy_city_placeholder

private fun init_pharmacy_city_placeholder(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:pharmacy_city_placeholder", "pharmacy_city_placeholder",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6613, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9829, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6673, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6757, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6473, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6769, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9153, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5989, 53),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    9220, 45),
    )
)

internal val Res.string.pharmacy_data: StringResource
  get() = CommonMainString0.pharmacy_data

private fun init_pharmacy_data(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:pharmacy_data", "pharmacy_data",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6667, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9887, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6719, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6811, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6519, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6819, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9215, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6043, 37),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    9266, 41),
    )
)

internal val Res.string.pharmacy_name_label: StringResource
  get() = CommonMainString0.pharmacy_name_label

private fun init_pharmacy_name_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:pharmacy_name_label", "pharmacy_name_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6709, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9961, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6761, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6853, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6565, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6865, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9273, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6081, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    9308, 47),
    )
)

internal val Res.string.pharmacy_name_vat_label: StringResource
  get() = CommonMainString0.pharmacy_name_vat_label

private fun init_pharmacy_name_vat_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:pharmacy_name_vat_label", "pharmacy_name_vat_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6757, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10033, 87),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6809, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6901, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6621, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6917, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9341, 91),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6125, 67),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    9356, 59),
    )
)

internal val Res.string.pharmacy_pharmacist_fallback: StringResource
  get() = CommonMainString0.pharmacy_pharmacist_fallback

private fun init_pharmacy_pharmacist_fallback(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:pharmacy_pharmacist_fallback", "pharmacy_pharmacist_fallback",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    9416, 64),
    )
)

internal val Res.string.phone_label: StringResource
  get() = CommonMainString0.phone_label

private fun init_phone_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:phone_label", "phone_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6829, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10121, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6869, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6961, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6681, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6981, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9433, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6193, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    9481, 51),
    )
)

internal val Res.string.phone_row: StringResource
  get() = CommonMainString0.phone_row

private fun init_phone_row(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:phone_row", "phone_row",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6873, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10197, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6913, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7009, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6733, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7029, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9513, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6233, 25),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    9533, 29),
    )
)

internal val Res.string.processing: StringResource
  get() = CommonMainString0.processing

private fun init_processing(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:processing", "processing",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    9563, 38),
    )
)

internal val Res.string.professional_data: StringResource
  get() = CommonMainString0.professional_data

private fun init_professional_data(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:professional_data", "professional_data",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6903, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10239, 85),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6939, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7039, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6767, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7059, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9551, 85),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6259, 41),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    9602, 49),
    )
)

internal val Res.string.profile_detail_title: StringResource
  get() = CommonMainString0.profile_detail_title

private fun init_profile_detail_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:profile_detail_title", "profile_detail_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6953, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10325, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6989, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7093, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6829, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7113, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9637, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6301, 44),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    9652, 52),
    )
)

internal val Res.string.profile_pharmacy: StringResource
  get() = CommonMainString0.profile_pharmacy

private fun init_profile_pharmacy(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:profile_pharmacy", "profile_pharmacy",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7002, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10406, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7038, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7146, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6882, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7166, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9702, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6346, 40),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    9705, 48),
    )
)

internal val Res.string.profile_professional: StringResource
  get() = CommonMainString0.profile_professional

private fun init_profile_professional(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:profile_professional", "profile_professional",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7047, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10475, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7087, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7191, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6931, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7215, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9763, 92),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6387, 44),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    9754, 56),
    )
)

internal val Res.string.progress_title: StringResource
  get() = CommonMainString0.progress_title

private fun init_progress_title(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:progress_title", "progress_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7144, 42),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    9811, 46),
    )
)

internal val Res.string.proposer_label: StringResource
  get() = CommonMainString0.proposer_label

private fun init_proposer_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:proposer_label", "proposer_label",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    9858, 46),
    )
)

internal val Res.string.province_label: StringResource
  get() = CommonMainString0.province_label

private fun init_province_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:province_label", "province_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7173, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10645, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7268, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7325, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7069, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7353, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9953, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6505, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    9986, 34),
    )
)

internal val Res.string.province_label_caps: StringResource
  get() = CommonMainString0.province_label_caps

private fun init_province_label_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:province_label_caps", "province_label_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7092, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10556, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7187, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7244, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6988, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7272, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9856, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6432, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    9905, 39),
    )
)

internal val Res.string.province_label_short: StringResource
  get() = CommonMainString0.province_label_short

private fun init_province_label_short(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:province_label_short", "province_label_short",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7132, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10600, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7227, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7284, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7028, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7312, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9904, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6468, 36),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    9945, 40),
    )
)

internal val Res.string.publish_availability_caps: StringResource
  get() = CommonMainString0.publish_availability_caps

private fun init_publish_availability_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:publish_availability_caps", "publish_availability_caps",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    10021, 65),
    )
)

internal val Res.string.publish_entire_batch: StringResource
  get() = CommonMainString0.publish_entire_batch

private fun init_publish_entire_batch(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:publish_entire_batch", "publish_entire_batch",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7208, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10684, 116),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7303, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7360, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7104, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7392, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10000, 96),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6540, 64),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    10087, 72),
    )
)

internal val Res.string.publish_shift_request_title: StringResource
  get() = CommonMainString0.publish_shift_request_title

private fun init_publish_shift_request_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:publish_shift_request_title", "publish_shift_request_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7289, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10801, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7368, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7429, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7169, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7457, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10097, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6605, 59),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    10160, 67),
    )
)

internal val Res.string.range_festive_applied: StringResource
  get() = CommonMainString0.range_festive_applied

private fun init_range_festive_applied(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:range_festive_applied", "range_festive_applied",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    10228, 93),
    )
)

internal val Res.string.range_festive_notice: StringResource
  get() = CommonMainString0.range_festive_notice

private fun init_range_festive_notice(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:range_festive_notice", "range_festive_notice",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    10322, 100),
    )
)

internal val Res.string.rate_label_header: StringResource
  get() = CommonMainString0.rate_label_header

private fun init_rate_label_header(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:rate_label_header", "rate_label_header",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7369, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10909, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7432, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7497, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7237, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7525, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10205, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6665, 33),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    10423, 37),
    )
)

internal val Res.string.rate_label_pharmacist: StringResource
  get() = CommonMainString0.rate_label_pharmacist

private fun init_rate_label_pharmacist(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:rate_label_pharmacist", "rate_label_pharmacist",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7403, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10947, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7466, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7531, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7271, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7559, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10247, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6699, 49),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    10461, 49),
    )
)

internal val Res.string.rate_label_pharmacy: StringResource
  get() = CommonMainString0.rate_label_pharmacy

private fun init_rate_label_pharmacy(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:rate_label_pharmacy", "rate_label_pharmacy",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7449, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11017, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7516, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7577, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7325, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7609, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10309, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6749, 47),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    10511, 43),
    )
)

internal val Res.string.received_from: StringResource
  get() = CommonMainString0.received_from

private fun init_received_from(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:received_from", "received_from",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7497, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11085, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7560, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7621, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7373, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7657, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10377, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6797, 37),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    10555, 37),
    )
)

internal val Res.string.region_label: StringResource
  get() = CommonMainString0.region_label

private fun init_region_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:region_label", "region_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7604, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11244, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7671, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7736, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7484, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7772, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10512, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6904, 32),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    10670, 32),
    )
)

internal val Res.string.region_label_caps: StringResource
  get() = CommonMainString0.region_label_caps

private fun init_region_label_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:region_label_caps", "region_label_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7535, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11135, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7602, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7659, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7407, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7695, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10427, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6835, 33),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    10593, 37),
    )
)

internal val Res.string.region_label_short: StringResource
  get() = CommonMainString0.region_label_short

private fun init_region_label_short(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:region_label_short", "region_label_short",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7569, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11189, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7636, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7697, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7445, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7733, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10469, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6869, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    10631, 38),
    )
)

internal val Res.string.register_button_caps: StringResource
  get() = CommonMainString0.register_button_caps

private fun init_register_button_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:register_button_caps", "register_button_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7637, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11297, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7704, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7769, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7517, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7805, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10553, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6937, 36),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    10703, 44),
    )
)

internal val Res.string.register_title_screen: StringResource
  get() = CommonMainString0.register_title_screen

private fun init_register_title_screen(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:register_title_screen", "register_title_screen",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7682, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11346, 89),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7745, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7814, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7562, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7846, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10630, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6974, 45),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    10748, 45),
    )
)

internal val Res.string.registration_success_message: StringResource
  get() = CommonMainString0.registration_success_message

private fun init_registration_success_message(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:registration_success_message", "registration_success_message",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7732, 112),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11436, 168),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7795, 92),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7860, 92),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7616, 88),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7892, 92),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10700, 136),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7020, 92),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    10794, 92),
    )
)

internal val Res.string.registration_success_title: StringResource
  get() = CommonMainString0.registration_success_title

private fun init_registration_success_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:registration_success_title", "registration_success_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7845, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11605, 94),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7888, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7953, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7705, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7985, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10837, 90),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7113, 54),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    10887, 70),
    )
)

internal val Res.string.reject_button: StringResource
  get() = CommonMainString0.reject_button

private fun init_reject_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:reject_button", "reject_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7920, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11700, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7955, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8020, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7772, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8048, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10928, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7168, 29),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    10958, 33),
    )
)

internal val Res.string.release_shift_button: StringResource
  get() = CommonMainString0.release_shift_button

private fun init_release_shift_button(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:release_shift_button", "release_shift_button",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    10992, 44),
    )
)

internal val Res.string.remember_me_label: StringResource
  get() = CommonMainString0.remember_me_label

private fun init_remember_me_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:remember_me_label", "remember_me_label",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    11037, 69),
    )
)

internal val Res.string.remove_button: StringResource
  get() = CommonMainString0.remove_button

private fun init_remove_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:remove_button", "remove_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7954, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11746, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7985, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8054, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7806, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8082, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10974, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7198, 29),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    11107, 33),
    )
)

internal val Res.string.remove_favorites: StringResource
  get() = CommonMainString0.remove_favorites

private fun init_remove_favorites(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:remove_favorites", "remove_favorites",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7988, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11792, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8015, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8084, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7840, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8116, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11016, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7228, 48),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    11141, 52),
    )
)

internal val Res.string.reputation_insufficient_data: StringResource
  get() = CommonMainString0.reputation_insufficient_data

private fun init_reputation_insufficient_data(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:reputation_insufficient_data", "reputation_insufficient_data",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8045, 92),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11877, 124),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8068, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8137, 88),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7893, 92),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8169, 88),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11097, 128),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7277, 84),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    11194, 84),
    )
)

internal val Res.string.reputation_title: StringResource
  get() = CommonMainString0.reputation_title

private fun init_reputation_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:reputation_title", "reputation_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8138, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12002, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8153, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8226, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7986, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8258, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11226, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7362, 40),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    11279, 48),
    )
)

internal val Res.string.reset_filters: StringResource
  get() = CommonMainString0.reset_filters

private fun init_reset_filters(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:reset_filters", "reset_filters",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8175, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12051, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8198, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8271, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8035, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8303, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11287, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7403, 37),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    11328, 41),
    )
)

internal val Res.string.saturday: StringResource
  get() = CommonMainString0.saturday

private fun init_saturday(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:saturday", "saturday",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8225, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12117, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8240, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8321, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8089, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8345, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11353, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7441, 28),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    11370, 24),
    )
)

internal val Res.string.save_button: StringResource
  get() = CommonMainString0.save_button

private fun init_save_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:save_button", "save_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8254, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12154, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8269, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8350, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8114, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8374, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11390, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7470, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    11395, 27),
    )
)

internal val Res.string.save_changes: StringResource
  get() = CommonMainString0.save_changes

private fun init_save_changes(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:save_changes", "save_changes",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8286, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12202, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8297, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8382, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8150, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8402, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11434, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7498, 36),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    11423, 40),
    )
)

internal val Res.string.search_pharmacies_subtitle: StringResource
  get() = CommonMainString0.search_pharmacies_subtitle

private fun init_search_pharmacies_subtitle(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:search_pharmacies_subtitle", "search_pharmacies_subtitle",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8335, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12271, 154),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8334, 82),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8423, 86),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8211, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8451, 90),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11507, 134),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7535, 86),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    11464, 86),
    )
)

internal val Res.string.search_pharmacies_title: StringResource
  get() = CommonMainString0.search_pharmacies_title

private fun init_search_pharmacies_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:search_pharmacies_title", "search_pharmacies_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8406, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12426, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8417, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8510, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8286, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8542, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11642, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7622, 47),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    11551, 55),
    )
)

internal val Res.string.search_pharmacists_title: StringResource
  get() = CommonMainString0.search_pharmacists_title

private fun init_search_pharmacists_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:search_pharmacists_title", "search_pharmacists_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8458, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12510, 92),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8473, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8566, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8354, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8602, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11702, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7670, 52),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    11607, 56),
    )
)

internal val Res.string.select_at_least_one_date: StringResource
  get() = CommonMainString0.select_at_least_one_date

private fun init_select_at_least_one_date(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:select_at_least_one_date", "select_at_least_one_date",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8515, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12603, 124),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8530, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8627, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8419, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8667, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11779, 96),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7723, 68),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    11664, 68),
    )
)

internal val Res.string.select_availability_range: StringResource
  get() = CommonMainString0.select_availability_range

private fun init_select_availability_range(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:select_availability_range", "select_availability_range",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8592, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12728, 109),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8595, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8700, 77),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8496, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8740, 85),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11876, 105),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7792, 61),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    11733, 77),
    )
)

internal val Res.string.select_button: StringResource
  get() = CommonMainString0.select_button

private fun init_select_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:select_button", "select_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8650, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12838, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8665, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8778, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8578, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8826, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11982, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7854, 29),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    11811, 33),
    )
)

internal val Res.string.select_dates: StringResource
  get() = CommonMainString0.select_dates

private fun init_select_dates(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:select_dates", "select_dates",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8688, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12880, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8695, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8816, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8620, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8864, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12024, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7884, 36),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    11845, 40),
    )
)

internal val Res.string.select_language: StringResource
  get() = CommonMainString0.select_language

private fun init_select_language(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:select_language", "select_language",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8733, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12953, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8732, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8861, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8669, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8909, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12077, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7921, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    11886, 47),
    )
)

internal val Res.string.select_period_title: StringResource
  get() = CommonMainString0.select_period_title

private fun init_select_period_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:select_period_title", "select_period_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    11934, 51),
    )
)

internal val Res.string.select_role: StringResource
  get() = CommonMainString0.select_role

private fun init_select_role(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:select_role", "select_role",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8777, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13017, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8776, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8909, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8717, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8957, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12137, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7961, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    11986, 39),
    )
)

internal val Res.string.select_shift_range: StringResource
  get() = CommonMainString0.select_shift_range

private fun init_select_shift_range(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:select_shift_range", "select_shift_range",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8821, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13073, 82),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8812, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8949, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8769, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9005, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12193, 82),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7997, 50),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    12026, 58),
    )
)

internal val Res.string.selected_count_label: StringResource
  get() = CommonMainString0.selected_count_label

private fun init_selected_count_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:selected_count_label", "selected_count_label",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    12085, 52),
    )
)

internal val Res.string.send_report_button: StringResource
  get() = CommonMainString0.send_report_button

private fun init_send_report_button(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:send_report_button", "send_report_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8880, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13156, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8863, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9008, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8832, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9072, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12276, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8048, 42),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    12138, 50),
    )
)

internal val Res.string.sent_by: StringResource
  get() = CommonMainString0.sent_by

private fun init_sent_by(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:sent_by", "sent_by",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8927, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13235, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8906, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9055, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8871, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9123, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12343, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8091, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    12223, 31),
    )
)

internal val Res.string.sent_by_short: StringResource
  get() = CommonMainString0.sent_by_short

private fun init_sent_by_short(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:sent_by_short", "sent_by_short",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    12189, 33),
    )
)

internal val Res.string.settings_title: StringResource
  get() = CommonMainString0.settings_title

private fun init_settings_title(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:settings_title", "settings_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8959, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13283, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8934, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9087, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8903, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9155, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12387, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8119, 30),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    12255, 38),
    )
)

internal val Res.string.shifts_ready_to_publish: StringResource
  get() = CommonMainString0.shifts_ready_to_publish

private fun init_shifts_ready_to_publish(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:shifts_ready_to_publish", "shifts_ready_to_publish",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9002, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13330, 111),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8969, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9122, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8942, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9194, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12434, 95),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8150, 63),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    12294, 79),
    )
)

internal val Res.string.single_date_caps: StringResource
  get() = CommonMainString0.single_date_caps

private fun init_single_date_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:single_date_caps", "single_date_caps",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    12374, 40),
    )
)

internal val Res.string.skills_filter_label: StringResource
  get() = CommonMainString0.skills_filter_label

private fun init_skills_filter_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:skills_filter_label", "skills_filter_label",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    12415, 55),
    )
)

internal val Res.string.start_label: StringResource
  get() = CommonMainString0.start_label

private fun init_start_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:start_label", "start_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9082, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13442, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9041, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9194, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9018, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9270, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12530, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8214, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    12471, 27),
    )
)

internal val Res.string.status_accepted: StringResource
  get() = CommonMainString0.status_accepted

private fun init_status_accepted(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:status_accepted", "status_accepted",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9110, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13478, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9069, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9222, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9046, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9302, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12566, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8242, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    12540, 35),
    )
)

internal val Res.string.status_accepted_caps: StringResource
  get() = CommonMainString0.status_accepted_caps

private fun init_status_accepted_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:status_accepted_caps", "status_accepted_caps",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    12499, 40),
    )
)

internal val Res.string.status_cancelled: StringResource
  get() = CommonMainString0.status_cancelled

private fun init_status_cancelled(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:status_cancelled", "status_cancelled",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9150, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13526, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9105, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9258, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9082, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9334, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12610, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8278, 36),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    12576, 36),
    )
)

internal val Res.string.status_confirmed: StringResource
  get() = CommonMainString0.status_confirmed

private fun init_status_confirmed(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:status_confirmed", "status_confirmed",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9187, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13575, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9142, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9295, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9119, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9371, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12659, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8315, 44),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    12613, 48),
    )
)

internal val Res.string.status_in_progress: StringResource
  get() = CommonMainString0.status_in_progress

private fun init_status_in_progress(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:status_in_progress", "status_in_progress",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    12662, 38),
    )
)

internal val Res.string.status_proposed: StringResource
  get() = CommonMainString0.status_proposed

private fun init_status_proposed(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:status_proposed", "status_proposed",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9236, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13652, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9179, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9344, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9168, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9420, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12732, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8360, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    12701, 35),
    )
)

internal val Res.string.status_rejected: StringResource
  get() = CommonMainString0.status_rejected

private fun init_status_rejected(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:status_rejected", "status_rejected",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9280, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13708, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9215, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9380, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9204, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9456, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12784, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8396, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    12737, 35),
    )
)

internal val Res.string.status_waiting: StringResource
  get() = CommonMainString0.status_waiting

private fun init_status_waiting(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:status_waiting", "status_waiting",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9316, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13760, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9251, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9416, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9240, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9492, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12832, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8432, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    12773, 34),
    )
)

internal val Res.string.storico_title: StringResource
  get() = CommonMainString0.storico_title

private fun init_storico_title(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:storico_title", "storico_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    12808, 53),
    )
)

internal val Res.string.sunday: StringResource
  get() = CommonMainString0.sunday

private fun init_sunday(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:sunday", "sunday",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9351, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13811, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9286, 22),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9451, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9279, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9547, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12879, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8467, 26),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    12862, 26),
    )
)

internal val Res.string.support_alternative: StringResource
  get() = CommonMainString0.support_alternative

private fun init_support_alternative(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:support_alternative", "support_alternative",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9378, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13846, 143),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9309, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9478, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9306, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9574, 91),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12926, 151),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8494, 75),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    12889, 87),
    )
)

internal val Res.string.support_email_body: StringResource
  get() = CommonMainString0.support_email_body

private fun init_support_email_body(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:support_email_body", "support_email_body",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9446, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13990, 210),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9393, 146),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9554, 154),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9366, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9666, 166),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    13078, 234),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8570, 150),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    12977, 154),
    )
)

internal val Res.string.support_email_subject: StringResource
  get() = CommonMainString0.support_email_subject

private fun init_support_email_subject(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:support_email_subject", "support_email_subject",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9493, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    14201, 85),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9540, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9709, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9413, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9833, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    13313, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8721, 85),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    13132, 81),
    )
)

internal val Res.string.support_feedback: StringResource
  get() = CommonMainString0.support_feedback

private fun init_support_feedback(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:support_feedback", "support_feedback",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9619, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    14335, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9666, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9835, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9539, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9959, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    13443, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8847, 44),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    13258, 52),
    )
)

internal val Res.string.support_feedback_option: StringResource
  get() = CommonMainString0.support_feedback_option

private fun init_support_feedback_option(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:support_feedback_option", "support_feedback_option",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9575, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    14287, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9622, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9791, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9495, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9915, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    13395, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8807, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    13214, 43),
    )
)

internal val Res.string.support_intro: StringResource
  get() = CommonMainString0.support_intro

private fun init_support_intro(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:support_intro", "support_intro",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9672, 93),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    14416, 233),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9715, 121),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9884, 133),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9592, 89),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10008, 133),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    13516, 221),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8892, 121),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    13311, 133),
    )
)

internal val Res.string.support_message_label: StringResource
  get() = CommonMainString0.support_message_label

private fun init_support_message_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:support_message_label", "support_message_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9766, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    14650, 93),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9837, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10018, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9682, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10142, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    13738, 89),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9014, 57),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    13445, 69),
    )
)

internal val Res.string.support_message_placeholder: StringResource
  get() = CommonMainString0.support_message_placeholder

private fun init_support_message_placeholder(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:support_message_placeholder", "support_message_placeholder",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9820, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    14744, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9899, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10080, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9736, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10208, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    13828, 95),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9072, 71),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    13515, 67),
    )
)

internal val Res.string.support_other_option: StringResource
  get() = CommonMainString0.support_other_option

private fun init_support_other_option(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:support_other_option", "support_other_option",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9888, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    14852, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9971, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10156, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9792, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10280, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    13924, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9144, 36),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    13583, 36),
    )
)

internal val Res.string.support_report_option: StringResource
  get() = CommonMainString0.support_report_option

private fun init_support_report_option(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:support_report_option", "support_report_option",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9929, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    14893, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10008, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10193, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9829, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10317, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    13969, 85),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9181, 45),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    13620, 57),
    )
)

internal val Res.string.support_technical_option: StringResource
  get() = CommonMainString0.support_technical_option

private fun init_support_technical_option(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:support_technical_option", "support_technical_option",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9971, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    14967, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10054, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10247, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9875, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10379, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14055, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9227, 48),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    13678, 56),
    )
)

internal val Res.string.support_title: StringResource
  get() = CommonMainString0.support_title

private fun init_support_title(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:support_title", "support_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10032, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15044, 77),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10107, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10304, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9936, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10436, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14140, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9276, 41),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    13735, 49),
    )
)

internal val Res.string.support_type_label: StringResource
  get() = CommonMainString0.support_type_label

private fun init_support_type_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:support_type_label", "support_type_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10082, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15122, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10157, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10350, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9986, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10482, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14210, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9318, 46),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    13785, 42),
    )
)

internal val Res.string.surname_label: StringResource
  get() = CommonMainString0.surname_label

private fun init_surname_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:surname_label", "surname_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10160, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15220, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10239, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10432, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10060, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10564, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14300, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9400, 29),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    13867, 33),
    )
)

internal val Res.string.surname_label_caps: StringResource
  get() = CommonMainString0.surname_label_caps

private fun init_surname_label_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:surname_label_caps", "surname_label_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10121, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15173, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10200, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10393, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10029, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10525, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14253, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9365, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    13828, 38),
    )
)

internal val Res.string.surname_row: StringResource
  get() = CommonMainString0.surname_row

private fun init_surname_row(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:surname_row", "surname_row",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10194, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15262, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10273, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10466, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10086, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10598, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14342, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9430, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    13901, 31),
    )
)

internal val Res.string.tab_ads: StringResource
  get() = CommonMainString0.tab_ads

private fun init_tab_ads(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:tab_ads", "tab_ads",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10226, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15302, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10305, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10498, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10110, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10630, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14382, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9458, 23),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    13933, 27),
    )
)

internal val Res.string.tab_home: StringResource
  get() = CommonMainString0.tab_home

private fun init_tab_home(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:tab_home", "tab_home",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10254, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15342, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10325, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10526, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10138, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10658, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14426, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9482, 24),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    13961, 24),
    )
)

internal val Res.string.tab_profile: StringResource
  get() = CommonMainString0.tab_profile

private fun init_tab_profile(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:tab_profile", "tab_profile",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10279, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15375, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10350, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10551, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10167, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10687, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14463, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9507, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    13986, 31),
    )
)

internal val Res.string.tab_search: StringResource
  get() = CommonMainString0.tab_search

private fun init_tab_search(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:tab_search", "tab_search",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10307, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15411, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10382, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10579, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10195, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10715, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14503, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9535, 26),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    14018, 26),
    )
)

internal val Res.string.tax_code_error_invalid: StringResource
  get() = CommonMainString0.tax_code_error_invalid

private fun init_tax_code_error_invalid(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:tax_code_error_invalid", "tax_code_error_invalid",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10334, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15454, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10409, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10606, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10226, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10746, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14538, 126),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9562, 66),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    14045, 86),
    )
)

internal val Res.string.tax_code_error_length: StringResource
  get() = CommonMainString0.tax_code_error_length

private fun init_tax_code_error_length(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:tax_code_error_length", "tax_code_error_length",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10389, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15521, 141),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10484, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10673, 89),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10281, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10797, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14665, 133),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9629, 69),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    14132, 93),
    )
)

internal val Res.string.tax_code_label: StringResource
  get() = CommonMainString0.tax_code_label

private fun init_tax_code_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:tax_code_label", "tax_code_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10507, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15699, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10598, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10795, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10403, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10899, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14835, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9735, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    14262, 46),
    )
)

internal val Res.string.tax_code_label_caps: StringResource
  get() = CommonMainString0.tax_code_label_caps

private fun init_tax_code_label_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:tax_code_label_caps", "tax_code_label_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10471, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15663, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10558, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10763, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10363, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10867, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14799, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9699, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    14226, 35),
    )
)

internal val Res.string.tax_code_row: StringResource
  get() = CommonMainString0.tax_code_row

private fun init_tax_code_row(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:tax_code_row", "tax_code_row",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10550, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15734, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10641, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10830, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10446, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10930, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14894, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9770, 28),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    14309, 40),
    )
)

internal val Res.string.thursday: StringResource
  get() = CommonMainString0.thursday

private fun init_thursday(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:thursday", "thursday",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10587, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15763, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10674, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10863, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10483, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10955, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14951, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9799, 28),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    14350, 28),
    )
)

internal val Res.string.time_active_now: StringResource
  get() = CommonMainString0.time_active_now

private fun init_time_active_now(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:time_active_now", "time_active_now",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    14379, 39),
    )
)

internal val Res.string.time_label_header: StringResource
  get() = CommonMainString0.time_label_header

private fun init_time_label_header(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:time_label_header", "time_label_header",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10620, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15796, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10703, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10888, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10508, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10988, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14988, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9828, 33),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    14419, 33),
    )
)

internal val Res.string.time_remaining: StringResource
  get() = CommonMainString0.time_remaining

private fun init_time_remaining(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:time_remaining", "time_remaining",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    14453, 34),
    )
)

internal val Res.string.total_per_shift: StringResource
  get() = CommonMainString0.total_per_shift

private fun init_total_per_shift(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:total_per_shift", "total_per_shift",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10658, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15830, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10737, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10926, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10546, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11026, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15030, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9862, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    14488, 39),
    )
)

internal val Res.string.tuesday: StringResource
  get() = CommonMainString0.tuesday

private fun init_tuesday(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:tuesday", "tuesday",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10702, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15890, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10777, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10966, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10586, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11066, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15090, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9906, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    14528, 27),
    )
)

internal val Res.string.type_min_chars: StringResource
  get() = CommonMainString0.type_min_chars

private fun init_type_min_chars(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:type_min_chars", "type_min_chars",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10730, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15922, 126),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10805, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10990, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10610, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11098, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15126, 90),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9934, 62),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    14556, 62),
    )
)

internal val Res.string.user_not_logged_in: StringResource
  get() = CommonMainString0.user_not_logged_in

private fun init_user_not_logged_in(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:user_not_logged_in", "user_not_logged_in",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10797, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    16049, 106),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10868, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11057, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10677, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11165, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15217, 82),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9997, 46),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    14619, 50),
    )
)

internal val Res.string.vat_label_caps: StringResource
  get() = CommonMainString0.vat_label_caps

private fun init_vat_label_caps(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:vat_label_caps", "vat_label_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10860, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    16156, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10919, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11112, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10740, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11228, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15300, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10044, 38),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    14670, 30),
    )
)

internal val Res.string.vat_number: StringResource
  get() = CommonMainString0.vat_number

private fun init_vat_number(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:vat_number", "vat_number",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10895, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    16187, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10946, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11139, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10767, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11255, 22),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15331, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10083, 54),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    14701, 34),
    )
)

internal val Res.string.view_in_calendar: StringResource
  get() = CommonMainString0.view_in_calendar

private fun init_view_in_calendar(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:view_in_calendar", "view_in_calendar",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10926, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    16214, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10981, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11170, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10802, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11278, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15378, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10138, 48),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    14736, 52),
    )
)

internal val Res.string.waiting_counterparty: StringResource
  get() = CommonMainString0.waiting_counterparty

private fun init_waiting_counterparty(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:waiting_counterparty", "waiting_counterparty",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10975, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    16295, 148),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    11030, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11219, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10859, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11327, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15459, 116),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10187, 56),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    14789, 84),
    )
)

internal val Res.string.waiting_final_confirmation: StringResource
  get() = CommonMainString0.waiting_final_confirmation

private fun init_waiting_final_confirmation(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:waiting_final_confirmation", "waiting_final_confirmation",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    11052, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    16444, 174),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    11115, 98),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11300, 98),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10932, 82),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11408, 98),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15576, 170),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10244, 78),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    14874, 102),
    )
)

internal val Res.string.wednesday: StringResource
  get() = CommonMainString0.wednesday

private fun init_wednesday(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:wednesday", "wednesday",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    11131, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    16619, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    11214, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11399, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    11015, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11507, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15747, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10323, 29),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    14977, 33),
    )
)

internal val Res.string.welcome: StringResource
  get() = CommonMainString0.welcome

private fun init_welcome(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:welcome", "welcome",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    11206, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    16722, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    11277, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11470, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    11078, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11574, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15838, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10390, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    15044, 31),
    )
)

internal val Res.string.welcome_back: StringResource
  get() = CommonMainString0.welcome_back

private fun init_welcome_back(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:welcome_back", "welcome_back",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    11161, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    16657, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    11244, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11433, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    11045, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11541, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15781, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10353, 36),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    15011, 32),
    )
)

internal val Res.string.yes: StringResource
  get() = CommonMainString0.yes

private fun init_yes(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:yes", "yes",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    11305, 15),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    15111, 15),
    )
)

internal val Res.string.yes_cancel: StringResource
  get() = CommonMainString0.yes_cancel

private fun init_yes_cancel(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:yes_cancel", "yes_cancel",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    15076, 34),
    )
)

internal val Res.string.your_active_ads: StringResource
  get() = CommonMainString0.your_active_ads

private fun init_your_active_ads(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:your_active_ads", "your_active_ads",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    11238, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    16770, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    11321, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11502, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    11110, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11606, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15898, 87),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10418, 47),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    15127, 51),
    )
)

internal val Res.string.your_proposal: StringResource
  get() = CommonMainString0.your_proposal

private fun init_your_proposal(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:your_proposal", "your_proposal",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    11290, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    16854, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    11365, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11554, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    11162, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11658, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15986, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10466, 37),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    15179, 37),
    )
)

internal val Res.string.zone_label_header: StringResource
  get() = CommonMainString0.zone_label_header

private fun init_zone_label_header(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:zone_label_header", "zone_label_header",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    11332, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    16908, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    11407, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11592, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    11208, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11696, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    16052, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/farmafreelance.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10504, 33),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmafreelance.composeapp.generated.resources/values/strings.commonMain.cvr",
    15217, 33),
    )
)
